"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4089],{

/***/ 21776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24969);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65299);




var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function EmptyState(param) {
    var _description = param.description, description = _description === void 0 ? "Add your favourite investors and monitor your stocks" : _description, onDiscover = param.onDiscover;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .EmptyStateWrapper */ .$c, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Img */ .Ei, {
                src: "/images/empty_stream_box.png",
                alt: "Empty stream"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .ContentWrapper */ .vs, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        family: "bold",
                        size: "18px",
                        mb: "10px",
                        children: "Your Stream is Empty"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        size: "16px",
                        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray,
                        weight: "bold",
                        mb: "32px",
                        children: description
                    }),
                    onDiscover ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .ButtonDiscover */ .$A, {
                        onClick: onDiscover,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                style: {
                                    marginRight: "8px"
                                }
                            }),
                            "Discover"
                        ]
                    }) : null
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (EmptyState);


/***/ }),

/***/ 65299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ ButtonDiscover; },
/* harmony export */   "$c": function() { return /* binding */ EmptyStateWrapper; },
/* harmony export */   "Ei": function() { return /* binding */ Img; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 60vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 32px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  height: 44px;\n  margin: auto;\n  width: 200px;\n\n  :hover {\n    // TODO: Add Color to @stockbit/ui\n    background: #3a3a3a;\n    border-color: #3a3a3a;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button;
var EmptyStateWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-62a242ea-0"
})(_templateObject());
var Img = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-62a242ea-1"
})(_templateObject1());
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-62a242ea-2"
})(_templateObject2(), Text);
var ButtonDiscover = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).attrs({
    type: "primary"
}).withConfig({
    componentId: "sc-62a242ea-3"
})(_templateObject3());



/***/ }),

/***/ 90668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76825);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2497);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);
/* harmony import */ var global_ModalShare__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41232);
/* harmony import */ var lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10707);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(333);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(36084);
/* harmony import */ var hooks_useTooltip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30627);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86123);
/* harmony import */ var features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99093);
/* harmony import */ var utils_source__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9486);
/* harmony import */ var _Modals__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50700);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97986);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47225);
/* harmony import */ var _tests_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(18278);
/* eslint-disable no-unused-vars */ 




















var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Text */ .Gn.Text, Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Iconmoon */ .Gn.Iconmoon, IconWrapper = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.IconWrapper */ .Gn.IconWrapper;
var LS_TOOLTIP_SHARE = "tooltipShare";
function Footer(param) {
    var post = param.post, onComment = param.onComment, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _hideLikers = param.hideLikers, hideLikers = _hideLikers === void 0 ? false : _hideLikers, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost;
    var pageSource = (0,utils_source__WEBPACK_IMPORTED_MODULE_12__/* .getAnalyticsPageSource */ .u)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_8__/* .selectors */ .wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref1 = (0,hooks_useTooltip__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(LS_TOOLTIP_SHARE), showShareTolltip = ref1.showTooltip, onCloseShareTooltip = ref1.onCloseTooltip;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalShare = ref2[0], showModalShare = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalInsight = ref3[0], showModalInsight = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalTipping = ref4[0], showModalTipping = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalLike = ref5[0], showModalLike = ref5[1];
    var likes = post.likes, replies = post.replies, liked = post.liked, postid = post.postid;
    // TODO: handle logic in footer
    /**
   * - Handle like post -> button after liked/unliked (DONE)
   * - Open modal conversation
   * - Hide tipjar icon if post.userid === current userid
   */ var handleLikePost = function() {
        var action = liked ? _slice__WEBPACK_IMPORTED_MODULE_15__/* .effects.unlikePost */ .Sz.unlikePost : _slice__WEBPACK_IMPORTED_MODULE_15__/* .effects.likePost */ .Sz.likePost;
        // @ts-ignore
        dispatch(action(postid));
    };
    var handleShareToChat = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chatData) {
            var send, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_7__/* .effects.sendBulkChat */ .Sz.sendBulkChat((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, chatData), {
                            attachment_url: "",
                            shared_content: {
                                type: "SHARED_CONTENT_TYPE_STREAM",
                                id: post.postid
                            }
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            showModalShare(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickShare = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_11__/* ["default"].common.Action.clickShareButton */ .ZP.common.Action.clickShareButton(pageSource);
        }
        showModalShare(true);
    };
    var handleClickTip = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_11__/* ["default"].common.Action.clickTipping */ .ZP.common.Action.clickTipping({
                pageSource: pageSource,
                streamId: post.postid,
                userId: post.userid
            });
        }
        showModalTipping(true);
    };
    var urlToShare = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var path = !constants_app__WEBPACK_IMPORTED_MODULE_10__/* .PROJECT_FOLDER */ .sP || constants_app__WEBPACK_IMPORTED_MODULE_10__/* .PROJECT_FOLDER */ .sP === "/" ? "/" : "/".concat(constants_app__WEBPACK_IMPORTED_MODULE_10__/* .PROJECT_FOLDER */ .sP, "/");
        return "".concat(window.location.origin).concat(path, "post/").concat(post.postid);
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_14__/* .FooterContainer */ .bk, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                justify: "space-between",
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                        align: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    !hideLikers ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                                        as: "a",
                                        className: "likes-info",
                                        onClick: function() {
                                            return showModalLike(true);
                                        },
                                        children: likes > 0 && "".concat(likes, " likes")
                                    }) : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Flex, {
                                        padding: "10px 20px 0 0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                            onClick: handleLikePost,
                                            "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_LIKE_BUTTON_COMPANY */ .KL : _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_LIKE_BUTTON */ .l,
                                            children: liked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like-fill.svg",
                                                alt: "Like post filled",
                                                style: {
                                                    width: "20px"
                                                }
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like.svg",
                                                alt: "Like post",
                                                style: {
                                                    width: "20px"
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Flex, {
                                padding: "0 20px 0 0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    placement: "top",
                                    title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                                        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.light */ .$_.light,
                                        family: "bold",
                                        size: "12px",
                                        height: "22px",
                                        onClick: onCloseShareTooltip,
                                        children: "Share to friends"
                                    }),
                                    defaultVisible: showShareTolltip && isFirstPost,
                                    visible: showShareTolltip && isFirstPost,
                                    overlayClassName: "tooltip-overlay-green",
                                    overlayInnerStyle: {
                                        background: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.primary */ .$_.primary,
                                        padding: "6px 8px"
                                    },
                                    zIndex: 99,
                                    arrowPointAtCenter: true,
                                    onVisibleChange: function(open) {
                                        return onCloseShareTooltip();
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                        onClick: handleClickShare,
                                        "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_SHARE_BUTTON_COMPANY */ .H9 : _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_SHARE_BUTTON */ .On,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            src: "/icon/post-stream/share.svg",
                                            alt: "Share post",
                                            style: {
                                                width: "20px"
                                            }
                                        })
                                    })
                                })
                            }),
                            post.analytics && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                padding: "0 20px 0 0",
                                onClick: function() {
                                    return showModalInsight(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Iconmoon, {
                                    className: "icon-new_analytics",
                                    size: "16px",
                                    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.dimgray */ .$_.dimgray,
                                    hoverColor: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.dimgray */ .$_.dimgray
                                })
                            }),
                            !post.is_author && country === "ID" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                padding: "0 20px 0 0",
                                onClick: handleClickTip,
                                "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_TIP_BUTTON_COMPANY */ .tJ : _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_TIP_BUTTON */ .vI,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/icon-tip.svg",
                                    alt: "Icon Tip",
                                    style: {
                                        width: "20px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                        onClick: onComment,
                        style: {
                            alignItems: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                                padding: "0 8px 0",
                                children: parseInt(replies, 10) > 0 && replies
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/comment.svg",
                                    alt: "Icon Comment New",
                                    style: {
                                        width: "20px"
                                    },
                                    "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_STREAM_COMMENT_ICON_COMPANY */ .dJ : _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_STREAM_COMMENT_ICON */ .Vi
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ModalShare__WEBPACK_IMPORTED_MODULE_6__["default"], {
                post: post,
                sendChat: handleShareToChat,
                title: "Share",
                hasCopyButton: true,
                hasRepostButton: post.is_author === 0,
                hasSearchPeople: true,
                hasSocialMedia: true,
                hasShareInput: true,
                urlToShare: urlToShare,
                visible: modalShare,
                onCancel: function() {
                    return showModalShare(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_13__/* .ModalInsight */ .eV, {
                visible: modalInsight,
                post: post,
                onCancel: function() {
                    return showModalInsight(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_13__/* .ModalTipping */ .MW, {
                streamId: postid,
                userId: post.userid,
                username: post.username,
                avatar: post.avatar,
                visible: modalTipping,
                onCancel: function() {
                    return showModalTipping(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_13__/* .ModalLike */ .gU, {
                likes: likes,
                streamId: postid,
                visible: modalLike,
                onCancel: function() {
                    return showModalLike(false);
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 82592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);


var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, IconWrapper = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconWrapper */ .Gn.IconWrapper, Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Iconmoon */ .Gn.Iconmoon, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function PinnedLabel(param) {
    var isCompanyPinnedPost = param.isCompanyPinnedPost, _text = param.text, text = _text === void 0 ? "Pinned Post" : _text, _marginBottom = param.marginBottom, marginBottom = _marginBottom === void 0 ? "16px" : _marginBottom;
    var color = isCompanyPinnedPost ? "#858585" : "#e32072";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
        ml: isCompanyPinnedPost ? "0px" : "50px",
        align: "center",
        mb: marginBottom,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Iconmoon, {
                    className: "icon-toolbar_pinned",
                    size: "16px",
                    color: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                ml: isCompanyPinnedPost ? "4px" : "8px",
                color: color,
                children: text
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PinnedLabel);


/***/ }),

/***/ 3841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreamWidget_Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/ImageSlider/index.tsx + 7 modules
var ImageSlider = __webpack_require__(9649);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/StreamWidget/PollingContainer/index.tsx + 2 modules
var PollingContainer = __webpack_require__(78690);
// EXTERNAL MODULE: ./src/global/StreamWidget/TargetPriceContainer/index.tsx + 2 modules
var TargetPriceContainer = __webpack_require__(18562);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var styled = __webpack_require__(97986);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/Comment.tsx












var Flex = ui/* Common.Flex */.Gn.Flex, Avatar = ui/* Common.Avatar */.Gn.Avatar;
function Comment(_param) {
    var comment = _param.comment, props = (0,_object_without_properties/* default */.Z)(_param, [
        "comment"
    ]);
    var avatar = comment.avatar, content = comment.content, maskedHtml = comment.mask_html, username = comment.username, created = comment.created_display, official = comment.official, isVerified = comment.is_verified, privilege = comment.user_priv;
    var avatarUrl = avatar.startsWith("http") ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    // Note :
    // From backend in stream post the type of official param is number
    // but stream post inside the last_reply have official param type string
    var isOfficial = official > 0 || isVerified;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CommentContainer */.bQ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                    mb: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                            size: "x-small",
                            padding: "0 10px 0 0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "imageProfile",
                                src: avatarUrl,
                                onError: function(e) {
                                    return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(username),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                                family: "bold",
                                                size: "14px",
                                                children: username
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                            deprecatedVerifiedStatus: isOfficial,
                                            verifiedStatus: comment === null || comment === void 0 ? void 0 : comment.verified_status
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelAdmin */.SH, {
                                            privilege: privilege
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                    size: "12px",
                                    color: ui/* color.midgray */.$_.midgray,
                                    children: created
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                    content: content,
                    maskedHtml: maskedHtml,
                    style: {
                        marginBottom: "0px"
                    },
                    needParsed: false
                })
            ]
        })
    }));
}
/* harmony default export */ var Post_Comment = (Comment);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/DocumentContainer.tsx
var DocumentContainer = __webpack_require__(55424);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Header.tsx
var Header = __webpack_require__(5373);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/PinnedLabel.tsx
var PinnedLabel = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/RepostBox.tsx
var RepostBox = __webpack_require__(38294);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/TitleContent.tsx + 1 modules
var TitleContent = __webpack_require__(41447);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/YoutubePlayer.tsx
var YoutubePlayer = __webpack_require__(74132);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Footer.tsx
var Footer = __webpack_require__(90668);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/index.tsx
/* eslint-disable react/require-default-props */ /* eslint-disable indent */ /* eslint-disable camelcase */ 




















var Post_Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var GuestFooter = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4597).then(__webpack_require__.bind(__webpack_require__, 4597));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4597)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var FollowingActivity = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1895).then(__webpack_require__.bind(__webpack_require__, 81895));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81895)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
function Post(param) {
    var post = param.post, onComment = param.onComment, _pinned = param.pinned, pinned = _pinned === void 0 ? false : _pinned, _showLatestComment = param.showLatestComment, showLatestComment = _showLatestComment === void 0 ? true : _showLatestComment, _hasFollowingActivity = param.hasFollowingActivity, hasFollowingActivity = _hasFollowingActivity === void 0 ? true : _hasFollowingActivity, _expandContent = param.expandContent, expandContent = _expandContent === void 0 ? false : _expandContent, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost, _isSinglePost = param.isSinglePost, isSinglePost = _isSinglePost === void 0 ? false : _isSinglePost, _highlightWord = param.highlightWord, highlightWord = _highlightWord === void 0 ? "" : _highlightWord, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, entryPoint = param.entryPoint, dataCyName = param.dataCyName;
    var ref, ref1;
    var content = post.content, content_original = post.content_original, images = post.images, attachment = post.attachment, polling = post.polling, target_price = post.target_price, last_reply = post.last_reply, mask_html = post.mask_html, reposted = post.reposted, repostedfrom = post.repostedfrom, title = post.title, titleurl = post.titleurl, images_data = post.images_data, image_frame_type = post.image_frame_type, followingActivity = post.following_activity, isAuthor = post.is_author;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var imagesData = (0,react.useMemo)(function() {
        var listImage = (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0] !== "" ? images.map(function(i) {
            return {
                image: i
            };
        }) : [];
        listImage = listImage.filter(function(i) {
            var exist = images_data.find(function(img) {
                return img.image === i.image;
            });
            return !exist;
        });
        listImage = (0,_to_consumable_array/* default */.Z)(listImage).concat((0,_to_consumable_array/* default */.Z)(images_data));
        return listImage;
    }, [
        post
    ]);
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0 && ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.image));
    var showFollowingActivity = (followingActivity === null || followingActivity === void 0 ? void 0 : (ref1 = followingActivity.users) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && hasFollowingActivity;
    var autoplayYoutube = !isSinglePost;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* StreamBoxContainer */.Vj, {
        "data-cy": dataCyName,
        children: [
            pinned && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedLabel/* default */.Z, {
                isCompanyPinnedPost: entryPoint === "symbol"
            }),
            showFollowingActivity && /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowingActivity, {
                data: followingActivity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                post: post,
                isLoggedIn: isLoggedIn,
                entryPoint: entryPoint,
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentWrapper */.vs, {
                children: [
                    (polling === null || polling === void 0 ? void 0 : polling.length) && isLoggedIn > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer/* default */.Z, {
                        post: post,
                        isSinglePost: isSinglePost,
                        isTextDefaultExpand: expandContent,
                        highlightWord: highlightWord
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TextContainer */.lU, {
                                children: [
                                    title && titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent/* default */.Z, {
                                        title: title,
                                        highlightWord: highlightWord,
                                        titleUrl: titleurl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                        content: content,
                                        maskedHtml: mask_html,
                                        isDefaultExpand: expandContent,
                                        highlightWord: highlightWord
                                    }),
                                    post.newsfeed_source && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_Flex, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                alt: post.newsfeed_label,
                                                src: post.newsfeed_img,
                                                style: {
                                                    width: "16px",
                                                    marginRight: "8px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                size: "12px",
                                                children: post.newsfeed_label
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isHaveImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                                images: imagesData,
                                frameType: image_frame_type,
                                isSinglePost: isSinglePost
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                                content: content_original,
                                autoplay: autoplayYoutube
                            }),
                            isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (attachment === null || attachment === void 0 ? void 0 : attachment.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentContainer/* default */.Z, {
                                        documents: attachment
                                    }),
                                    (target_price === null || target_price === void 0 ? void 0 : target_price.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceContainer/* default */.Z, {
                                        targetPrice: target_price[0],
                                        postid: post.postid,
                                        isAuthor: isAuthor
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    reposted > 0 && isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(RepostBox/* default */.Z, {
                        post: repostedfrom
                    }),
                    isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                        post: post,
                        onComment: onComment,
                        isFirstPost: isFirstPost,
                        symbol: symbol
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestFooter, {
                        post: post
                    })
                ]
            }),
            isLoggedIn && showLatestComment && last_reply && Object.keys(last_reply).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Comment, {
                comment: last_reply,
                onClick: onComment
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_Post = (Post);


/***/ }),

/***/ 23023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3503);


function Skeleton() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonBox */ .HX, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonLeft */ .yt, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonAvatar */ .JT, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonRight */ .wW, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonUsername */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonDate */ .hT, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonContent */ .vP, {})
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Skeleton);


/***/ }),

/***/ 3503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HX": function() { return /* binding */ StreamSkeletonBox; },
/* harmony export */   "JT": function() { return /* binding */ StreamSkeletonAvatar; },
/* harmony export */   "Tg": function() { return /* binding */ StreamSkeletonContainer; },
/* harmony export */   "Z": function() { return /* binding */ StreamSkeletonUsername; },
/* harmony export */   "hT": function() { return /* binding */ StreamSkeletonDate; },
/* harmony export */   "mN": function() { return /* binding */ ShortBar; },
/* harmony export */   "mr": function() { return /* binding */ LongBar; },
/* harmony export */   "pl": function() { return /* binding */ Thumbnail; },
/* harmony export */   "vP": function() { return /* binding */ StreamSkeletonContent; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "wW": function() { return /* binding */ StreamSkeletonRight; },
/* harmony export */   "yt": function() { return /* binding */ StreamSkeletonLeft; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: solid 1px ",
        ";\n  padding: 20px;\n\n  &:last-child {\n    border: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  gap: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #F7F7F7;\n  border-radius: 4px;\n  height: 16px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 30%;\n\n  @media ",
        " {\n    width: 20%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: ",
        ";\n    min-width: ",
        ";\n    width: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 6px;\n  margin-left: 33px;\n  height: 75px;\n  width: 100px;\n  min-width: 100px;\n\n  @media ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid #ededed;\n  padding: 20px;\n  position: relative;\n  background: #fff;\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 50px;\n  width: 50px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40px;\n  height: 40px;\n  background: #f7f7f7;\n  border-radius: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 50px;\n  width: calc(100% - 50px);\n  position: relative;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 229px;\n  height: 16px;\n  background: #f7f7f7;\n  border-radius: 4px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 87px;\n  height: 16px;\n  background: #f7f7f7;\n  border-radius: 4px;\n  margin-top: 8px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 88px;\n  background: #f7f7f7;\n  border-radius: 4px;\n  margin-top: 20px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex;
var StreamSkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e0687d94-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var ContentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    direction: "column",
    justify: "center"
}).withConfig({
    componentId: "sc-e0687d94-1"
})(_templateObject1());
var LongBar = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e0687d94-2"
})(_templateObject2());
var ShortBar = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(LongBar).withConfig({
    componentId: "sc-e0687d94-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var Thumbnail = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(LongBar).withConfig({
    componentId: "sc-e0687d94-4"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, function(param) {
    var height = param.height, width = param.width;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject4(), height, width, width);
});
var StreamSkeletonBox = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e0687d94-5"
})(_templateObject6());
var StreamSkeletonLeft = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e0687d94-6"
})(_templateObject7());
var StreamSkeletonAvatar = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e0687d94-7"
})(_templateObject8());
var StreamSkeletonRight = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e0687d94-8"
})(_templateObject9());
var StreamSkeletonUsername = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e0687d94-9"
})(_templateObject10());
var StreamSkeletonDate = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e0687d94-10"
})(_templateObject11());
var StreamSkeletonContent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e0687d94-11"
})(_templateObject12());



/***/ }),

/***/ 54089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_StreamWidget; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/back-top/index.js + 3 modules
var back_top = __webpack_require__(28682);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./src/global/WebSocket/slice.ts
var slice = __webpack_require__(23985);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/features/user/slice.ts
var user_slice = __webpack_require__(52827);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/global/QueryProvider/index.tsx
var QueryProvider = __webpack_require__(62780);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/notes.ts


var NOTES_URL = "".concat(api/* API_EXODUS_URL */.q7, "/notes");
var request = (0,requestExodus/* default */.Z)();
var postNotes = function(payload) {
    return request.post(NOTES_URL, payload);
};
var getNotes = function(params) {
    return request.get(NOTES_URL, {
        params: params
    });
};
var putNotes = function(payload, id) {
    return request.put("".concat(NOTES_URL, "/").concat(id), payload);
};
var deleteNotes = function(id) {
    return request.delete("".concat(NOTES_URL, "/").concat(id));
};

// EXTERNAL MODULE: ./src/utils/uploadStreamFiles.ts + 1 modules
var uploadStreamFiles = __webpack_require__(93589);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/NotesCompose/Header/CompanyIcon.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #3A645C;\n  border-radius: 50%;\n  color: ",
        ";\n  display: flex;\n  min-height: 38px;\n  min-width: 38px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ImagePlaceholder = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-60ffb5aa-0"
})(_templateObject(), ui/* color.light */.$_.light);
var CompanyIcon = function(param) {
    var symbol = param.symbol;
    var ref = (0,react.useState)(true), isIconAvailable = ref[0], setIsIconAvailable = ref[1];
    if (isIconAvailable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "".concat(app/* assetsStatic */.mM, "/logos/companies/").concat(symbol, ".png"),
            alt: symbol,
            width: 38,
            height: 38,
            onError: function() {
                return setIsIconAvailable(false);
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceholder, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
            children: !!symbol && symbol.toUpperCase().slice(0, 1)
        })
    });
};
/* harmony default export */ var Header_CompanyIcon = (CompanyIcon);

;// CONCATENATED MODULE: ./src/global/NotesCompose/Header/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 4px 26px;\n  gap: 9px;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #EDEDED;\n  border-radius: 11.5px;\n  background: #F7F7F7;\n  width: max-content;\n  cursor: pointer;\n  padding: 4px 8px;\n  gap: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var HeaderContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2703ff0f-0"
})(styled_templateObject());
var ViewSettingContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2703ff0f-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/global/NotesCompose/Header/index.tsx





var Text = ui/* Common.Text */.Gn.Text, Flex = ui/* Common.Flex */.Gn.Flex;
var Header = function(param) {
    var symbol = param.symbol, name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_CompanyIcon, {
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        align: "center",
                        style: {
                            gap: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                weight: "bold",
                                children: symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                size: "12px",
                                color: "#858585",
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewSettingContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/notes/notes-eyes-off.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                size: "11px",
                                color: "#858585",
                                children: "Only you can see this"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NotesCompose_Header = (Header);

// EXTERNAL MODULE: ./src/lib/entities/user.js
var user = __webpack_require__(16992);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var company = __webpack_require__(74645);
// EXTERNAL MODULE: ./node_modules/antd/es/mentions/index.js + 7 modules
var mentions = __webpack_require__(46457);
;// CONCATENATED MODULE: ./src/global/NotesCompose/styled.ts

function NotesCompose_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    NotesCompose_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none !important;\n  box-shadow: none !important;\n  font-family: 'ProximaNovaRg';\n  margin-bottom: 12px;\n  resize: none;\n  width: 100%;\n\n  textarea {\n    padding: 18px 26px;\n  }\n\n  :focus {\n    outline: none;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div {\n    .ant-mentions-dropdown-menu-item {\n      border-bottom: 1px solid #f5f6f5;\n      height: 40px;\n\n      & > div {\n        height: -webkit-fill-available;\n      }\n    }\n    .ant-mentions-dropdown-menu-item-active {\n      p {\n        font-family: var(--font-bold) !important;\n      }\n    }\n    .ant-mentions-dropdown-menu-item-disabled {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 20vh;\n  width: 100%;\n  overflow-y: scroll;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 18px 26px 0 26px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 139px;\n  height: 20px;\n  background: #f7f7f7;\n  border-radius: 4px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 20px;\n  background: #f7f7f7;\n  border-radius: 4px;\n  margin-top: 8px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 142px\n  background: #f7f7f7;\n  border-radius: 4px;\n  margin-top: 8px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 52px;\n  height: 16px; \n  background: #f7f7f7;\n  border-radius: 4px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var styled_HeaderContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e91fc2c-0"
})(NotesCompose_styled_templateObject());
var TextareaMentions = (0,styled_components_browser_esm["default"])(mentions/* default */.Z).attrs(function(props) {
    return {
        placeholder: props.placeholder || "Tulis ide kamu di sini...",
        autoSize: {
            minRows: 3
        }
    };
}).withConfig({
    componentId: "sc-5e91fc2c-1"
})(styled_templateObject1());
var MentionSuggestionResult = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e91fc2c-2"
})(_templateObject2());
var ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e91fc2c-3"
})(_templateObject3());
var NoteSkeletonContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e91fc2c-4"
})(_templateObject4());
var NoteSkeletonTitle = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e91fc2c-5"
})(_templateObject5());
var NoteSkeletonSubtitle = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e91fc2c-6"
})(_templateObject6());
var NoteSkeletonContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e91fc2c-7"
})(_templateObject7());
var NoteSkeletonCounter = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e91fc2c-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/global/NotesCompose/Textarea.tsx












var Textarea_Flex = ui/* Common.Flex */.Gn.Flex, Textarea_Text = ui/* Common.Text */.Gn.Text;
var MentionOption = mentions/* default.Option */.Z.Option;
function Textarea(_param) {
    var value = _param.value, onChange = _param.onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange"
    ]);
    var textareaRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(""), searchKeyword = ref[0], setSearchKeyword = ref[1];
    var ref1 = (0,react.useState)("@"), mentionPrefix = ref1[0], setMentionPrefix = ref1[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,es/* useSelector */.v9)(user/* selectors */.wl), _search = ref2.search, userSearch = _search.data;
    var ref3 = (0,es/* useSelector */.v9)(company/* selectors */.wl), _search1 = ref3.search, companySearch = _search1.data;
    var SEARCH_DATA = {
        $: {
            data: companySearch,
            dispatch: company/* effects.getSearchCompany */.Sz.getSearchCompany
        }
    };
    var debouncedSearch = (0,react.useCallback)(lodash_debounce_default()(function(keyword, prefix) {
        var action = SEARCH_DATA[prefix].dispatch;
        dispatch(action(keyword));
    }, 500), []);
    var handleSearch = function(keyword, prefix) {
        setSearchKeyword(keyword);
        setMentionPrefix(prefix);
        debouncedSearch(keyword, prefix);
    };
    var searchResult = (0,react.useMemo)(function() {
        if (searchKeyword.length >= 2) {
            var ref;
            return (ref = SEARCH_DATA[mentionPrefix]) === null || ref === void 0 ? void 0 : ref.data;
        }
        return [];
    }, [
        userSearch,
        companySearch,
        searchKeyword
    ]);
    (0,react.useEffect)(function() {
        // Place active cursor on last chart
        if (textareaRef.current) {
            var textarea = textareaRef.current.textarea;
            textarea.focus();
            textarea.selectionStart = value.length; // Move cursor to end
            textarea.selectionEnd = textarea.selectionStart;
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MentionSuggestionResult, {
                id: "compose-notes-container"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaMentions, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                ref: textareaRef,
                prefix: [
                    "$"
                ],
                value: value,
                onChange: onChange,
                onSearch: handleSearch,
                notFoundContent: null,
                getPopupContainer: function() {
                    return document.getElementById("compose-notes-container");
                },
                children: searchResult.map(function(_param, index) /*#__PURE__*/ {
                    var id = _param.id, name = _param.name, data = (0,_object_without_properties/* default */.Z)(_param, [
                        "id",
                        "name"
                    ]);
                    return (0,jsx_runtime.jsx)(MentionOption, {
                        value: name,
                        className: "compose-notes-option",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Textarea_Flex, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Textarea_Text, {
                                    mr: "8px",
                                    children: [
                                        mentionPrefix,
                                        name
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea_Text, {
                                    children: data.desc
                                })
                            ]
                        })
                    }, "".concat(id, "-").concat(index));
                })
            }))
        ]
    });
}
/* harmony default export */ var NotesCompose_Textarea = (Textarea);

;// CONCATENATED MODULE: ./src/global/NotesCompose/Footer/styled.ts

function Footer_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 11px 16px;\n  border-top: 1px solid #DADADA;\n"
    ]);
    Footer_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Footer_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 16px;\n  margin-left: 20px;\n  cursor: pointer;\n"
    ]);
    Footer_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FooterContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e1e2562b-0"
})(Footer_styled_templateObject());
var FooterIcon = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-e1e2562b-1"
})(Footer_styled_templateObject1());

;// CONCATENATED MODULE: ./src/global/NotesCompose/constants.ts
var MAX_NOTES_LENGTH = 1000;
var MAX_NOTES_IMAGES_COUNT = 10;
var MAX_NOTES_DOCUMENTS_COUNT = 5;
// max file size: 2MB
var MAX_FILE_SIZE_MB = 2;
var MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
var MAX_IMAGE_SIZE_MB = 2;
var MAX_IMAGE_SIZE = MAX_IMAGE_SIZE_MB * 1024 * 1024;
var ALLOWED_DOC_EXT = (/* unused pure expression or super */ null && ([
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpointtd",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", 
]));

;// CONCATENATED MODULE: ./src/global/NotesCompose/Footer/index.tsx







var Footer_Text = ui/* Common.Text */.Gn.Text, Footer_Flex = ui/* Common.Flex */.Gn.Flex;
var Footer = function(param) {
    var length = param.length, documents = param.documents, images = param.images, isLoading = param.isLoading, savedState = param.savedState, onSetImages = param.onSetImages, onSetDocuments = param.onSetDocuments;
    var pictureRef = (0,react.useRef)(null);
    var documentRef = (0,react.useRef)(null);
    // NOTE : Uncomment if product decided to allow usage of upload picture/document
    // const openPictureAttachment = () => {
    //   if (images.length <= MAX_NOTES_IMAGES_COUNT) {
    //     pictureRef.current.click();
    //   } else {
    //     alertMessage({
    //       content: `Max Allowed Upload Images is ${MAX_NOTES_IMAGES_COUNT} Images`,
    //       alertType: 'plain-default',
    //       messageType: 'error',
    //     });
    //   }
    // };
    // const openDocumentAttachment = () => {
    //   documentRef.current.click();
    // };
    // const processImages = async (imageFiles) =>
    //   Promise.all(
    //     imageFiles.map(
    //       async (imageFile) =>
    //         new Promise((resolve) => {
    //           const reader = new FileReader();
    //           reader.readAsArrayBuffer(imageFile);
    //           reader.onloadend = async (e) => {
    //             const imageType = imageFile.type;
    //             if (imageFile.size > MAX_IMAGE_SIZE) {
    //               resolve(false);
    //             }
    //             const imagePreviewUrl = URL.createObjectURL(imageFile);
    //             const data: ImageType = {
    //               preview: imagePreviewUrl,
    //               isNew: true,
    //             };
    //             if (imageType === 'image/jpeg' || imageType === 'image/jpg') {
    //               // in some case some image form not have
    //               // format that can be deleted exif, so we try catch this block
    //               // to prevent user cannot upload the image
    //               try {
    //                 // @ts-ignore
    //                 const deletedExif = deleteImageExif(
    //                   e.target.result,
    //                   imageType,
    //                 );
    //                 data.file = deletedExif;
    //               } catch (err) {
    //                 data.file = imageFile;
    //               }
    //             } else {
    //               data.file = imageFile;
    //             }
    //             resolve(data);
    //           };
    //         }),
    //     ),
    //   );
    // const handleChangePicture = async (e) => {
    //   e.preventDefault();
    //   const selectedFiles = e.target.files;
    //   const imageFiles = Array.from(selectedFiles);
    //   const processedImages = await processImages(imageFiles);
    //   const validImages = processedImages.filter((image) => image);
    //   const listImage = [...images, ...validImages];
    //   // prevent upload image more than 10
    //   const newListImage = listImage.length > MAX_NOTES_IMAGES_COUNT
    //     ? listImage.slice(0, MAX_NOTES_IMAGES_COUNT)
    //     : listImage;
    //   onSetImages(newListImage);
    //   // eslint-disable-next-line no-param-reassign
    //   e.target.value = null;
    // };
    // const handleChangeDocument = (e) => {
    //   e.preventDefault();
    //   const documentFiles = [...documents];
    //   if (
    //     e.target.files.length + documents.length > MAX_NOTES_DOCUMENTS_COUNT
    //   ) {
    //     return alertMessage({
    //       content: ERROR_MESSAGE.MAX_UPLOAD_FILES,
    //       alertType: 'default',
    //       messageType: 'error',
    //       hasCloseIcon: false,
    //     });
    //   }
    //   // validate documents
    //   Array.from(e.target.files).forEach((fileTarget: any) => {
    //     if (fileTarget.type.match('image.*')) {
    //       alertMessage({
    //         content: ERROR_MESSAGE.DOCUMENT_IMAGE_NOT_ALLOWED,
    //         alertType: 'default',
    //         messageType: 'error',
    //         hasCloseIcon: false,
    //       });
    //       return false;
    //     }
    //     if (fileTarget.size > MAX_FILE_SIZE) {
    //       alertMessage({
    //         content: `File too large. The maximum size is ${MAX_FILE_SIZE_MB}MB`,
    //         alertType: 'plain-default',
    //         messageType: 'error',
    //         hasCloseIcon: false,
    //       });
    //       return false;
    //     }
    //     const pdfPreviewUrl = URL.createObjectURL(fileTarget);
    //     documentFiles.push({
    //       preview: pdfPreviewUrl,
    //       file: fileTarget,
    //       isNew: true,
    //     });
    //   });
    //   if (documentFiles.length > 0 && documentFiles.length <= MAX_NOTES_DOCUMENTS_COUNT) {
    //     onSetDocuments(documentFiles);
    //   }
    //   // reset input file
    //   // eslint-disable-next-line no-param-reassign
    //   e.target.value = null;
    // };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                    condition: isLoading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteSkeletonCounter, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default.Else */.Z.Else, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_Text, {
                                color: "#B5B5B5",
                                size: "13px",
                                children: [
                                    length,
                                    "/",
                                    MAX_NOTES_LENGTH
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Flex, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Text, {
                    color: "#B5B5B5",
                    size: "13px",
                    children: savedState
                })
            })
        ]
    });
};
/* harmony default export */ var NotesCompose_Footer = (Footer);

;// CONCATENATED MODULE: ./src/global/NotesCompose/Attachment/styled.ts

function Attachment_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 28px;\n  padding-right: 14px;\n  padding-bottom: 24px;\n"
    ]);
    Attachment_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Attachment_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow-x: auto;\n  padding: 30px 0;\n"
    ]);
    Attachment_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-right: 8px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 4px;\n  top: 4px;\n  cursor: pointer;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  border: 1px solid ",
        ";\n  box-sizing: border-box;\n  border-radius: 6px;\n  width: 100%;\n  padding: 14px 16px;\n  margin-bottom: 10px;\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 4px;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-right: 12px;\n  max-height: 16px;\n  background: #ee4a49;\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var AttachmentContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fbd2c395-0"
})(Attachment_styled_templateObject());
var AttachmentImageContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fbd2c395-1"
})(Attachment_styled_templateObject1());
var ImageItemContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fbd2c395-2"
})(styled_templateObject2());
var CloseWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fbd2c395-3"
})(styled_templateObject3());
var AttachmentDocumentContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fbd2c395-4"
})(styled_templateObject4());
var DocumentItem = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fbd2c395-5"
})(styled_templateObject5(), ui/* color.downgray */.$_.downgray);
var ExtensionBadge = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-fbd2c395-6"
})(styled_templateObject6());

// EXTERNAL MODULE: ./src/global/ImageSlider/Modal/index.tsx + 2 modules
var Modal = __webpack_require__(52579);
;// CONCATENATED MODULE: ./src/global/NotesCompose/Attachment/Images.tsx






var Images = function(param) {
    var images = param.images, onSetImages = param.onSetImages;
    var ref = (0,react.useState)(false), showModalImages = ref[0], setShowModalImages = ref[1];
    var ref1 = (0,react.useState)(0), active = ref1[0], setActive = ref1[1];
    var transformedImages = (0,react.useMemo)(function() {
        return images.map(function(item) {
            return item.preview;
        });
    }, [
        images
    ]);
    var handleRemoveFile = function(index) {
        var imageList = (0,_to_consumable_array/* default */.Z)(images);
        imageList.splice(index, 1);
        onSetImages(imageList);
    };
    var onClickImage = function(i) {
        setActive(i);
        setShowModalImages(!showModalImages);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttachmentImageContainer, {
        children: [
            images.map(function(image, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageItemContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseWrapper, {
                            onClick: handleRemoveFile,
                            draggable: "false",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/notes/notes-remove-image.svg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: image.preview,
                            alt: "preview",
                            height: "180",
                            onClick: function() {
                                return onClickImage(i);
                            }
                        })
                    ]
                });
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                images: transformedImages,
                visible: showModalImages,
                onClose: function() {
                    return setShowModalImages(false);
                },
                active: active,
                setActive: setActive
            })
        ]
    });
};
/* harmony default export */ var Attachment_Images = (Images);

// EXTERNAL MODULE: ./src/global/StreamWidget/utils.ts
var utils = __webpack_require__(11237);
// EXTERNAL MODULE: ./src/global/StreamCompose/FileContainer/styled.ts
var styled = __webpack_require__(9571);
;// CONCATENATED MODULE: ./src/global/NotesCompose/Attachment/ModalDocumentPreview.tsx

function ModalDocumentPreview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 0px !important;\n  margin: 0;\n  max-width: unset;\n  .ant-modal-content {\n    position: unset;\n    background-color: transparent;\n    box-shadow: none;\n  }\n  .ant-modal-body {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    > div {\n        width: 100%;\n    }\n  }  \n"
    ]);
    ModalDocumentPreview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ModalDocumentPreview_Modal = ui/* Common.Modal */.Gn.Modal;
var ModalDocument = (0,styled_components_browser_esm["default"])(ModalDocumentPreview_Modal).withConfig({
    componentId: "sc-99d5800a-0"
})(ModalDocumentPreview_templateObject());

;// CONCATENATED MODULE: ./src/global/NotesCompose/Attachment/Documents.tsx









var PDFPreview = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9467).then(__webpack_require__.bind(__webpack_require__, 39467));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39467)
            ];
        }
    },
    ssr: false
});
var Documents_Flex = ui/* Common.Flex */.Gn.Flex, Documents_Text = ui/* Common.Text */.Gn.Text;
var Documents = function(param) {
    var documents = param.documents, onSetDocuments = param.onSetDocuments;
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = (0,react.useState)(null), selectedDocument = ref1[0], setSelectedDocument = ref1[1];
    var handleRemoveFile = function(file) {
        var docIndex = documents.findIndex(function(doc) {
            return doc.preview === file.preview;
        });
        var documentFiles = (0,_to_consumable_array/* default */.Z)(documents);
        documentFiles.splice(docIndex, 1);
        // remove file here
        onSetDocuments(documentFiles);
    };
    var documentList = (0,react.useMemo)(function() {
        return documents.map(function(doc) {
            var humanFilename = doc.isNew === true ? doc.file.name : (0,utils/* showFileName */.yk)(doc === null || doc === void 0 ? void 0 : doc.fileUrl);
            var parsedFileName = humanFilename.length > 33 ? "".concat(humanFilename.substr(0, 20), "...").concat(humanFilename.substr(humanFilename.length - 6, 6)) : humanFilename;
            return {
                preview: doc.preview,
                extension: "PDF",
                filename: parsedFileName
            };
        });
    }, [
        documents
    ]);
    var onClickDocument = function(doc) {
        setSelectedDocument(doc.preview);
        setShowModal(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttachmentDocumentContainer, {
        children: [
            documentList.map(function(doc) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DocumentItem, {
                    onClick: function() {
                        return onClickDocument(doc);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Documents_Flex, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtensionBadge, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Documents_Text, {
                                        color: "#FFFFFF",
                                        family: "bold",
                                        weight: "700",
                                        size: "9px",
                                        height: "16px",
                                        pt: "1px",
                                        children: doc.extension
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Documents_Text, {
                                    as: "a",
                                    color: "#333333",
                                    ellipsis: true,
                                    children: doc.filename
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* IconCloseFile */.f4, {
                            className: "icon-compose_close",
                            onClick: function() {
                                return handleRemoveFile(doc);
                            }
                        })
                    ]
                });
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDocument, {
                centered: true,
                closable: true,
                footer: null,
                visible: showModal,
                onCancel: function() {
                    return setShowModal(false);
                },
                style: {
                    width: 500,
                    position: "unset"
                },
                destroyOnClose: true,
                transitionName: "",
                maskTransitionName: "",
                maskStyle: {
                    backgroundColor: "rgba(18,18,18,0.7)"
                },
                maskClosable: true,
                width: 1000,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFPreview, {
                    src: selectedDocument,
                    shared: true,
                    maxHeight: "calc(100vh - 112px)",
                    initialVisibility: true
                })
            })
        ]
    });
};
/* harmony default export */ var Attachment_Documents = (Documents);

;// CONCATENATED MODULE: ./src/global/NotesCompose/Attachment/index.tsx




var Attachment = function(param) {
    var images = param.images, documents = param.documents, onSetImages = param.onSetImages, onSetDocuments = param.onSetDocuments;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttachmentContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Attachment_Images, {
                images: images,
                onSetImages: onSetImages
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Attachment_Documents, {
                documents: documents,
                onSetDocuments: onSetDocuments
            })
        ]
    });
};
/* harmony default export */ var NotesCompose_Attachment = (Attachment);

;// CONCATENATED MODULE: ./src/global/NotesCompose/index.tsx















var NotesCompose = function(param) {
    var defaultSymbol = param.defaultSymbol, companyName = param.companyName;
    var savedState = (0,react.useRef)("Draft");
    var isChanged = (0,react.useRef)(false);
    var isSaving = (0,react.useRef)(false);
    var previousContentRef = (0,react.useRef)("");
    var ref = (0,react.useState)(null), notesId = ref[0], setNotesId = ref[1];
    var ref1 = (0,react.useState)(""), content = ref1[0], setContent = ref1[1];
    var ref2 = (0,react.useState)([]), documents = ref2[0], setDocuments = ref2[1];
    var ref3 = (0,react.useState)([]), images = ref3[0], setImages = ref3[1];
    var isLoading = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "notes-load",
            defaultSymbol
        ],
        queryFn: function() {
            return getNotes({
                company_symbol: defaultSymbol
            });
        },
        onSuccess: function(param) {
            var data = param.data;
            var notesData = data.data.notes[0];
            if (notesData) {
                if (content.length === 0 && images.length === 0 && documents.length === 0) {
                    previousContentRef.current = notesData.content.text;
                    var documentList = notesData.attachment.file_urls.map(function(item) {
                        return {
                            fileUrl: item,
                            preview: item,
                            isNew: false
                        };
                    });
                    setContent(notesData.content.text);
                // NOTE : Uncomment if product decided to allow usage of upload picture/document
                // setImages(parseExistImages(notesData.attachment.image_urls));
                // setDocuments(documentList);
                }
                setNotesId(notesData.id);
            }
        },
        retry: 0,
        refetchOnWindowFocus: false,
        cacheTime: 0,
        staleTime: 0
    }).isLoading;
    var handleUploadFiles = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var newImageList, newDocumentList, needUploadedImages, needUploadedDocuments, uploadedImages, uploadedDocuments, tmp, listOfImageUrl, tmp1, listOfDocumentUrl;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newImageList = images.filter(function(item) {
                            return !item.isNew;
                        });
                        newDocumentList = documents.filter(function(item) {
                            return !item.isNew;
                        });
                        _ctx.prev = 2;
                        needUploadedImages = images.filter(function(item) {
                            return item.isNew;
                        });
                        needUploadedDocuments = documents.filter(function(item) {
                            return item.isNew;
                        });
                        _ctx.t0 = needUploadedImages.length > 0;
                        if (!_ctx.t0) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 9;
                        return (0,uploadStreamFiles/* uploadImages */.eg)(needUploadedImages);
                    case 9:
                        _ctx.t0 = _ctx.sent;
                    case 10:
                        uploadedImages = _ctx.t0;
                        _ctx.t1 = needUploadedDocuments.length > 0;
                        if (!_ctx.t1) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 15;
                        return (0,uploadStreamFiles/* uploadFileDocuments */.Ii)(needUploadedDocuments);
                    case 15:
                        _ctx.t1 = _ctx.sent;
                    case 16:
                        uploadedDocuments = _ctx.t1;
                        tmp = uploadedImages.data, listOfImageUrl = tmp === void 0 ? [] : tmp;
                        tmp1 = uploadedDocuments.data, listOfDocumentUrl = tmp1 === void 0 ? [] : tmp1;
                        if (listOfImageUrl.length > 0) {
                            listOfImageUrl.forEach(function(image) {
                                newImageList.push({
                                    preview: image,
                                    file: image,
                                    isNew: false
                                });
                            });
                        }
                        if (listOfDocumentUrl.length > 0) {
                            listOfDocumentUrl.forEach(function(image) {
                                newDocumentList.push({
                                    preview: image,
                                    fileUrl: image,
                                    isNew: false
                                });
                            });
                        }
                        _ctx.next = 26;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t2 = _ctx["catch"](2);
                        return _ctx.abrupt("return", {
                            error: _ctx.t2
                        });
                    case 26:
                        return _ctx.abrupt("return", {
                            newImageList: newImageList,
                            newDocumentList: newDocumentList
                        });
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    23
                ]
            ]);
        }));
        return function handleUploadFiles() {
            return _ref.apply(this, arguments);
        };
    }();
    var saveNoteMutation = (0,useMutation/* useMutation */.D)({
        mutationFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, newImageList, newDocumentList, listImage, putPayload, postPayload, response, notesData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(content === previousContentRef.current)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", null);
                    case 3:
                        isSaving.current = true;
                        previousContentRef.current = content;
                        _ctx.next = 7;
                        return handleUploadFiles();
                    case 7:
                        ref2 = _ctx.sent;
                        newImageList = ref2.newImageList;
                        newDocumentList = ref2.newDocumentList;
                        listImage = newImageList.map(function(item) {
                            return item.preview;
                        });
                        setImages(newImageList);
                        setDocuments(newDocumentList);
                        if (!notesId) {
                            _ctx.next = 22;
                            break;
                        }
                        if (!(content.length === 0)) {
                            _ctx.next = 18;
                            break;
                        }
                        _ctx.next = 17;
                        return deleteNotes(notesId);
                    case 17:
                        return _ctx.abrupt("return", {
                            action: "DELETE"
                        });
                    case 18:
                        putPayload = {
                            note: content,
                            image_urls: listImage,
                            file_urls: newDocumentList.map(function(item) {
                                return item.preview;
                            })
                        };
                        _ctx.next = 21;
                        return putNotes(putPayload, notesId);
                    case 21:
                        return _ctx.abrupt("return", {
                            action: "UPDATE"
                        });
                    case 22:
                        postPayload = {
                            company_symbol: defaultSymbol,
                            note: content,
                            image_urls: listImage,
                            file_urls: newDocumentList.map(function(item) {
                                return item.preview;
                            })
                        };
                        _ctx.next = 25;
                        return postNotes(postPayload);
                    case 25:
                        _ctx.next = 27;
                        return getNotes({
                            company_symbol: defaultSymbol
                        });
                    case 27:
                        response = _ctx.sent;
                        notesData = (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.notes[0];
                        if (notesData) {
                            setNotesId(notesData.id);
                        }
                        return _ctx.abrupt("return", {
                            action: "CREATE"
                        });
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        onSuccess: function(data) {
            isSaving.current = false;
            savedState.current = "Saved";
            isChanged.current = false;
            if (content === previousContentRef.current) {
                isChanged.current = false;
            } else {
                isChanged.current = true;
            }
            if (data.action === "DELETE") {
                setNotesId(null);
            }
        },
        onError: function() {
            isSaving.current = false;
        }
    });
    var forceSave = function(e) {
        if (isChanged.current && !isSaving.current) {
            e.preventDefault();
            saveNoteMutation.mutate();
        }
    };
    (0,react.useLayoutEffect)(function() {
        window.addEventListener("beforeunload", forceSave);
        return function() {
            if (!isSaving.current && isChanged.current) {
                saveNoteMutation.mutate();
            }
            window.removeEventListener("beforeunload", forceSave);
        };
    }, []);
    var autoSave = (0,react.useCallback)(lodash_debounce_default()(function() {
        if (!isSaving.current && isChanged.current) {
            saveNoteMutation.mutate();
        }
    }, 5000), []);
    var handleChangeContent = function(text) {
        isChanged.current = true;
        savedState.current = "Draft";
        if (text.length <= MAX_NOTES_LENGTH) {
            setContent(text);
        } else {
            var clippedText = text.slice(0, 1000);
            setContent(clippedText);
        }
        autoSave();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesCompose_Header, {
                symbol: defaultSymbol,
                name: companyName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                        condition: !isLoading,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesCompose_Textarea, {
                                onChange: handleChangeContent,
                                value: content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesCompose_Attachment, {
                                images: images,
                                documents: documents,
                                onSetImages: function(listImage) {
                                    setImages(listImage);
                                    isChanged.current = true;
                                },
                                onSetDocuments: function(listDocument) {
                                    setDocuments(listDocument);
                                    isChanged.current = true;
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoteSkeletonContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteSkeletonTitle, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteSkeletonSubtitle, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteSkeletonSubtitle, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteSkeletonContent, {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesCompose_Footer, {
                length: content === null || content === void 0 ? void 0 : content.length,
                documents: documents,
                images: images,
                isLoading: isLoading,
                onSetImages: function(listImage) {
                    setImages(listImage);
                    isChanged.current = true;
                },
                onSetDocuments: function(listDocument) {
                    setDocuments(listDocument);
                    isChanged.current = true;
                },
                savedState: savedState.current
            })
        ]
    });
};
/* harmony default export */ var global_NotesCompose = (NotesCompose);

// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var StreamWidget_slice = __webpack_require__(47225);
// EXTERNAL MODULE: ./src/global/StreamWidget/Skeleton/index.tsx
var Skeleton = __webpack_require__(23023);
// EXTERNAL MODULE: ./src/global/StreamWidget/Skeleton/styled.ts
var Skeleton_styled = __webpack_require__(3503);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Skeleton/News.tsx



var News_Flex = ui/* Common.Flex */.Gn.Flex;

function NewsSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styled/* StreamSkeletonContainer */.Tg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(News_Flex, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton_styled/* ContentWrapper */.vs, {
                    children: [
                        (0,_to_consumable_array/* default */.Z)(new Array(2)).map(function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styled/* LongBar */.mr, {});
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styled/* ShortBar */.mN, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styled/* Thumbnail */.pl, {
                    height: "75px",
                    width: "100px"
                })
            ]
        })
    });
}
/* harmony default export */ var News = (NewsSkeleton);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Skeleton/Research.tsx



var Research_Flex = ui/* Common.Flex */.Gn.Flex;

function ResearchSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styled/* StreamSkeletonContainer */.Tg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Research_Flex, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton_styled/* ContentWrapper */.vs, {
                    children: [
                        (0,_to_consumable_array/* default */.Z)(new Array(1)).map(function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styled/* LongBar */.mr, {});
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styled/* ShortBar */.mN, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styled/* Thumbnail */.pl, {
                    height: "90px",
                    width: "120px"
                })
            ]
        })
    });
}
/* harmony default export */ var Research = (ResearchSkeleton);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/index.tsx + 1 modules
var Post = __webpack_require__(3841);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var Post_styled = __webpack_require__(97986);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./src/global/StreamWidget/constants.ts
var constants = __webpack_require__(21390);
;// CONCATENATED MODULE: ./src/global/StreamWidget/NewsPost/styled.ts

function NewsPost_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: -webkit-box;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n\n"
    ]);
    NewsPost_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewsPost_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 10px;\n  position: relative;\n  width: 100%;\n  cursor: pointer;\n\n  @media ",
        " {\n    gap: 40px;\n  }\n"
    ]);
    NewsPost_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NewsPost_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  gap: 4px;\n\n  .content-text {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    display: none;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    font-size: 13px;\n  }\n\n  @media ",
        " {\n    gap: 8px;\n\n    .content-text {\n      display: -webkit-box;\n    }\n  }\n"
    ]);
    NewsPost_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NewsPost_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "-webkit-line-clamp: 3"
    ]);
    NewsPost_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NewsPost_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 24px;\n  -webkit-line-clamp: 3;\n\n  @media ",
        " {\n    -webkit-line-clamp: 2;\n    ",
        "\n  }\n"
    ]);
    NewsPost_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NewsPost_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 90px;\n  min-width: 120px;  \n  position: relative;\n  width: 120px;\n  background-color: #F7F7F7;\n  border-radius: 6px;\n"
    ]);
    NewsPost_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NewsPost_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 6px;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  width: 100%;\n"
    ]);
    NewsPost_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_Text = ui/* Common.Text */.Gn.Text;
var TextWithClamp = (0,styled_components_browser_esm["default"])(styled_Text).withConfig({
    componentId: "sc-207337e5-0"
})(NewsPost_styled_templateObject());
var NewsWrapper = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    justify: "space-between",
    as: "a"
}).withConfig({
    componentId: "sc-207337e5-1"
})(NewsPost_styled_templateObject1(), ui/* device.tablet */.Uh.tablet);
var ContentBox = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    direction: "column",
    justify: "space-between"
}).withConfig({
    componentId: "sc-207337e5-2"
})(NewsPost_styled_templateObject2(), ui/* device.tablet */.Uh.tablet);
var TitleContent = (0,styled_components_browser_esm["default"])(TextWithClamp).withConfig({
    componentId: "sc-207337e5-3"
})(NewsPost_styled_templateObject4(), ui/* device.laptop */.Uh.laptop, function(param) {
    var hasMoreLine = param.hasMoreLine;
    return hasMoreLine && (0,styled_components_browser_esm.css)(NewsPost_styled_templateObject3());
});
var ThumbnailBox = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-207337e5-4"
})(NewsPost_styled_templateObject5());
var Thumbnail = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-207337e5-5"
})(NewsPost_styled_templateObject6());


;// CONCATENATED MODULE: ./src/global/StreamWidget/NewsPost/index.tsx
/* eslint-disable react/no-unused-prop-types */ /* eslint-disable react/require-default-props */ 








var NewsPost_Footer = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 90668));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90668)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var NewsPost_Flex = ui/* Common.Flex */.Gn.Flex, NewsPost_Text = ui/* Common.Text */.Gn.Text;
var PostNews = function(param) {
    var post = param.post, onComment = param.onComment;
    var content = post.content, created_display = post.created_display, images = post.images, mask_html = post.mask_html, newsfeed_img = post.newsfeed_img, newsfeed_label = post.newsfeed_label, title = post.title, titleurl = post.titleurl, username = post.username;
    var imagesData = (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0] !== "" ? images : [];
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0);
    var thumbnailImage = isHaveImage && imagesData[0];
    var hasMoreLine = false;
    var labelText = newsfeed_label;
    var labelImage = newsfeed_img;
    if (!labelText) {
        var ref, ref1, ref2;
        // News in a special case - from manual HQ
        var newsUsername = username === null || username === void 0 ? void 0 : username.toLowerCase();
        labelText = (ref = constants/* nonSourceNews */.Hw[newsUsername]) === null || ref === void 0 ? void 0 : ref.label;
        hasMoreLine = (ref1 = constants/* nonSourceNews */.Hw[newsUsername]) === null || ref1 === void 0 ? void 0 : ref1.extend;
        labelImage = (ref2 = constants/* nonSourceNews */.Hw[newsUsername]) === null || ref2 === void 0 ? void 0 : ref2.image;
    }
    var textContent = content.replace(/(\n|\r\n)/g, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_styled/* StreamBoxContainer */.Vj, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsWrapper, {
                href: titleurl,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: function(e) {
                    if (!titleurl) {
                        e.preventDefault();
                        onComment();
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent, {
                                size: "18px",
                                family: "bold",
                                hasMoreLine: hasMoreLine,
                                children: title
                            }),
                            titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsPost_Flex, {
                                onClick: function(e) {
                                    return e.stopPropagation();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                    isRepost: true,
                                    content: textContent,
                                    maskedHtml: mask_html,
                                    className: "content-text",
                                    style: {
                                        margin: "0px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsPost_Flex, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        alt: labelText,
                                        src: labelImage,
                                        style: {
                                            width: "16px",
                                            height: "16px",
                                            marginRight: "4px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsPost_Text, {
                                        size: "12px",
                                        color: "#969696",
                                        children: [
                                            labelText,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsPost_Text, {
                                                as: "span",
                                                padding: "0px 4px",
                                                color: "#969696",
                                                children: "•"
                                            }),
                                            created_display
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isHaveImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail, {
                            src: thumbnailImage,
                            alt: "Stockbit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsPost_Footer, {
                post: post,
                onComment: onComment,
                hideLikers: true
            })
        ]
    });
};
/* harmony default export */ var NewsPost = (PostNews);

// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var ErrorHandlers_If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/lottie-web/build/player/lottie.js
var lottie = __webpack_require__(11248);
var lottie_default = /*#__PURE__*/__webpack_require__.n(lottie);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/styled.ts
/* eslint-disable space-infix-ops */ 
function Navigation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    align-items: center;\n    display: flex;\n    flex: 1;\n    justify-content: space-between;\n  }\n\n  @media ",
        " {\n    flex: 0;\n    justify-content: flex-start;\n  }\n"
    ]);
    Navigation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Navigation_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n      border: 1px solid ",
        ";\n      border-radius: 5px;\n    "
    ]);
    Navigation_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Navigation_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  padding: 3px 8px;\n  color: ",
        ";\n  border: none;\n  background-color: ",
        ";\n  cursor: pointer;\n  ",
        ";\n  :focus {\n    outline: 0;\n  }\n"
    ]);
    Navigation_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Navigation_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    Navigation_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Navigation_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  text-decoration: none;\n  line-height: 18px;\n  padding: 8px;\n  margin: 0;\n  white-space: nowrap;\n  font-size: 14px;\n  color: ",
        ";\n  cursor: pointer;\n  :hover {\n    background-color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    Navigation_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Navigation_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    Navigation_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Navigation_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  width: fit-content;\n  button {\n    min-height: 23px;\n    padding-left: 4px;\n    white-space: nowrap;\n    font-size: 14px;\n    color: ",
        ";\n    border: none;\n    background-color: ",
        ";\n    cursor: pointer;\n    :focus {\n      outline: 0;\n    }\n  }\n"
    ]);
    Navigation_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  box-shadow: 0 1px 8px 1px rgb(0 0 0 / 6%);\n  border-radius: 4px;\n  min-width: 160px;\n  padding: 8px;\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 30px;\n  margin-left: 10px;\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      border-top: none;\n      padding: 12px 15px;\n      display: block;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  padding: 5px 15px;\n\n  :hover {\n    border-color: ",
        " !important;\n  }\n\n  ::placeholder {\n    color: ",
        " !important;\n    text-transform: capitalize;\n  }\n\n  input::placeholder,\n  input::-webkit-input-placeholder {\n    color: #e4e4e4 !important;\n    text-transform: capitalize;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: 20px;\n      margin-bottom: 16px;\n      height: max-content;\n      overflow: unset;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  height: 0;\n  transition: all 0.3s ease-in-out;\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  height: 90px;\n  background-size: 130px;\n  background-repeat: no-repeat;\n  background-position: 20px 10px;\n  padding: 15px 0 15px 180px;\n  margin: 15px 20px;\n  border-bottom: 1px solid ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 10px 0 10px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px 20px;\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: scroll;\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0px;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  scrollbar-width: none;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  height: 56px;\n  margin: 0 -20px;\n  padding: 0 20px;\n  border-bottom: solid 1px ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  margin: 15px 0;\n  overflow-x: scroll;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  -webkit-box-shadow: 0 1px 8px 1px rgb(0 0 0 / 6%);\n  box-shadow: 0 1px 8px 1px rgb(0 0 0 / 6%);\n  border-radius: 3px;\n  min-width: 160px;\n  padding: 8px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 20px;\n      height: 20px;\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #ffffff;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background-color: #00ab6b;\n  border: 1px solid #00ab6b;\n  font-size: 10px;\n  padding: 2px;\n  margin-left: -4px;\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}



var Navigation_styled_Text = ui/* Common.Text */.Gn.Text, Navigation_styled_Flex = ui/* Common.Flex */.Gn.Flex, DatePicker = ui/* Common.DatePicker */.Gn.DatePicker, PopoverContentWrapper = ui/* Common.PopoverContentWrapper */.Gn.PopoverContentWrapper, Input = ui/* Common.Input */.Gn.Input;
var Tag = ui/* Notation.Tag */.gO.Tag;
/**
 *
 * NAVIGATION AREA
 *
 */ var WebContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c9bcaba2-0"
})(Navigation_styled_templateObject(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var StreamTypeWeb = (0,styled_components_browser_esm["default"])(Navigation_styled_Text).attrs({
    as: "button"
}).withConfig({
    componentId: "sc-c9bcaba2-1"
})(Navigation_styled_templateObject2(), ui/* color.midgray */.$_.midgray, ui/* color.light */.$_.light, function(param) {
    var active = param.active;
    return active && (0,styled_components_browser_esm.css)(Navigation_styled_templateObject1(), ui/* color.nightRider */.$_.nightRider, ui/* color.veryLightGrey */.$_.veryLightGrey);
});
var DropdownOption = (0,styled_components_browser_esm["default"])(Navigation_styled_Text).withConfig({
    componentId: "sc-c9bcaba2-2"
})(Navigation_styled_templateObject4(), ui/* color.suvaGrey */.$_.suvaGrey, ui/* color.aliceBlue */.$_.aliceBlue, function(param) {
    var active = param.active;
    return active && (0,styled_components_browser_esm.css)(Navigation_styled_templateObject3(), ui/* color.primary */.$_.primary);
});
var MobileContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c9bcaba2-3"
})(Navigation_styled_templateObject5(), ui/* device.tablet */.Uh.tablet);
var DropdContainer = (0,styled_components_browser_esm["default"])(Navigation_styled_Flex).withConfig({
    componentId: "sc-c9bcaba2-4"
})(Navigation_styled_templateObject6(), ui/* color.primary */.$_.primary, ui/* color.light */.$_.light);
var PopoverContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c9bcaba2-5"
})(styled_templateObject7());
/**
 *
 * SEARCH AREA
 *
 */ var InputDate = (0,styled_components_browser_esm["default"])(DatePicker).withConfig({
    componentId: "sc-c9bcaba2-6"
})(styled_templateObject8());
var AdvancedSearchWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c9bcaba2-7"
})(_templateObject10(), function(param) {
    var active = param.active;
    return active && (0,styled_components_browser_esm.css)(_templateObject9(), ui/* color.gainsboro */.$_.gainsboro);
});
var SearchInput = (0,styled_components_browser_esm["default"])(Input).withConfig({
    componentId: "sc-c9bcaba2-8"
})(_templateObject11(), ui/* color.downgray */.$_.downgray, ui/* color.downgray */.$_.downgray, ui/* color.downgray */.$_.downgray);
/**
 *
 * CONTAINER AREA
 *
 */ var SearchBoxContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c9bcaba2-9"
})(_templateObject13(), function(param) {
    var active = param.active;
    return active && (0,styled_components_browser_esm.css)(_templateObject12());
});
var OldSwitcherContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c9bcaba2-10"
})(_templateObject14(), function(param) {
    var backgroundImage = param.backgroundImage;
    return backgroundImage || "";
}, ui/* color.gainsboro */.$_.gainsboro);
var NewSwitcherContainer = (0,styled_components_browser_esm["default"])(Navigation_styled_Flex).withConfig({
    componentId: "sc-c9bcaba2-11"
})(_templateObject15());
var NavigationContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c9bcaba2-12"
})(_templateObject17(), function(param) {
    var streamType = param.streamType, category = param.category;
    return streamType === constants/* STREAM_TYPE.SYMBOL */.R5.SYMBOL && category !== "notes" && (0,styled_components_browser_esm.css)(_templateObject16(), ui/* color.gainsboro */.$_.gainsboro);
});
var FlexScrollable = (0,styled_components_browser_esm["default"])(Navigation_styled_Flex).withConfig({
    componentId: "sc-c9bcaba2-13"
})(_templateObject18());
var NavigationTabContainer = (0,styled_components_browser_esm["default"])(FlexScrollable).withConfig({
    componentId: "sc-c9bcaba2-14"
})(_templateObject19(), ui/* color.gainsboro */.$_.gainsboro);
var StreamMenuContainer = (0,styled_components_browser_esm["default"])(FlexScrollable).withConfig({
    componentId: "sc-c9bcaba2-15"
})(_templateObject20());
var DropdownWrapper = (0,styled_components_browser_esm["default"])(PopoverContentWrapper).withConfig({
    componentId: "sc-c9bcaba2-16"
})(_templateObject21());
var NewIndicator = (0,styled_components_browser_esm["default"])(Tag).withConfig({
    componentId: "sc-c9bcaba2-17"
})(_templateObject23(), function(param) {
    var _larger = param.larger, larger = _larger === void 0 ? false : _larger;
    return larger && (0,styled_components_browser_esm.css)(_templateObject22());
});


;// CONCATENATED MODULE: ./public/animation/lottie-euforia.json
var lottie_euforia_namespaceObject = JSON.parse('{"v":"5.6.2","fr":60,"ip":0,"op":120,"w":504,"h":186,"nm":"Star 2","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.75],"y":[1]},"o":{"x":[0.25],"y":[0]},"t":0,"s":[-25]},{"i":{"x":[0.75],"y":[1]},"o":{"x":[0.25],"y":[0]},"t":60,"s":[15]},{"t":119,"s":[-25]}],"ix":10},"p":{"a":0,"k":[30,120,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.066,0.095],[-0.001,0.116],[0.066,0.095],[0.108,0.043],[0,0],[0,0],[0.099,0.069],[0.121,-0.001],[0.096,-0.069],[0.038,-0.112],[0,0],[0,0],[0.069,-0.098],[-0.001,-0.12],[-0.069,-0.096],[-0.113,-0.037],[0,0],[0,0],[-0.097,-0.068],[-0.119,0],[-0.097,0.068],[-0.04,0.111],[0,0],[0,0]],"o":[[0.066,-0.095],[-0.002,-0.115],[-0.066,-0.095],[0,0],[0,0],[-0.04,-0.113],[-0.099,-0.069],[-0.119,0],[-0.096,0.069],[0,0],[0,0],[-0.114,0.04],[-0.069,0.098],[0,0.118],[0.069,0.096],[0,0],[0,0],[0.04,0.111],[0.097,0.068],[0.119,0],[0.097,-0.068],[0,0],[0,0],[0.109,-0.041]],"v":[[4.897,0.292],[5,-0.032],[4.895,-0.355],[4.628,-0.566],[1.625,-1.633],[0.551,-4.617],[0.337,-4.896],[0,-5],[-0.331,-4.895],[-0.537,-4.617],[-1.612,-1.633],[-4.614,-0.566],[-4.895,-0.354],[-5,-0.019],[-4.894,0.31],[-4.614,0.515],[-1.612,1.637],[-0.537,4.621],[-0.325,4.896],[0.007,5],[0.339,4.896],[0.551,4.621],[1.625,1.569],[4.628,0.501]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.043137256056,0.631372570992,0.419607847929,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[600,600],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.2],"y":[0]},"t":15,"s":[90]},{"i":{"x":[0.363],"y":[1]},"o":{"x":[0.287],"y":[0]},"t":45,"s":[0]},{"i":{"x":[0.563],"y":[1]},"o":{"x":[0.243],"y":[0]},"t":68,"s":[15]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.2],"y":[0]},"t":90,"s":[0]},{"t":119,"s":[90]}],"ix":10},"p":{"a":0,"k":[54,168,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.2,0.2,0.2],"y":[0,0,0]},"t":15,"s":[0,0,100]},{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.2,0.2,0.2],"y":[0,0,0]},"t":45,"s":[100,100,100]},{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.2,0.2,0.2],"y":[0,0,0]},"t":90,"s":[100,100,100]},{"t":119,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.04,0.057],[0,0.07],[0.04,0.057],[0.065,0.026],[0,0],[0,0],[0.059,0.041],[0.072,-0.001],[0.058,-0.041],[0.023,-0.067],[0,0],[0,0],[0.041,-0.059],[-0.001,-0.072],[-0.042,-0.057],[-0.068,-0.022],[0,0],[0,0],[-0.058,-0.041],[-0.071,0],[-0.058,0.041],[-0.024,0.067],[0,0],[0,0]],"o":[[0.04,-0.057],[-0.001,-0.069],[-0.04,-0.057],[0,0],[0,0],[-0.024,-0.068],[-0.059,-0.041],[-0.071,0],[-0.058,0.041],[0,0],[0,0],[-0.068,0.024],[-0.041,0.059],[0,0.071],[0.042,0.057],[0,0],[0,0],[0.024,0.067],[0.058,0.041],[0.071,0],[0.058,-0.041],[0,0],[0,0],[0.065,-0.025]],"v":[[2.938,0.175],[3,-0.019],[2.937,-0.213],[2.777,-0.34],[0.975,-0.98],[0.331,-2.77],[0.202,-2.938],[0,-3],[-0.199,-2.937],[-0.322,-2.77],[-0.967,-0.98],[-2.769,-0.34],[-2.937,-0.212],[-3,-0.011],[-2.936,0.186],[-2.769,0.309],[-0.967,0.982],[-0.322,2.772],[-0.195,2.937],[0.004,3],[0.204,2.937],[0.331,2.772],[0.975,0.941],[2.777,0.301]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.043137256056,0.631372570992,0.419607847929,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[600,600],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.2],"y":[0]},"t":30,"s":[-35]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.2],"y":[0]},"t":50,"s":[20]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.2],"y":[0]},"t":60,"s":[-10]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.2],"y":[0]},"t":70,"s":[15]},{"t":90,"s":[-35]}],"ix":10},"p":{"a":0,"k":[486,54,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.2,0.2,0.2],"y":[0,0,0]},"t":30,"s":[100,100,100]},{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.2,0.2,0.2],"y":[0,0,0]},"t":60,"s":[90,90,100]},{"t":90,"s":[100,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.04,0.057],[0,0.07],[0.04,0.057],[0.065,0.026],[0,0],[0,0],[0.059,0.041],[0.072,-0.001],[0.058,-0.041],[0.023,-0.067],[0,0],[0,0],[0.041,-0.059],[-0.001,-0.072],[-0.042,-0.057],[-0.068,-0.022],[0,0],[0,0],[-0.058,-0.041],[-0.071,0],[-0.058,0.041],[-0.024,0.067],[0,0],[0,0]],"o":[[0.04,-0.057],[-0.001,-0.069],[-0.04,-0.057],[0,0],[0,0],[-0.024,-0.068],[-0.059,-0.041],[-0.071,0],[-0.058,0.041],[0,0],[0,0],[-0.068,0.024],[-0.041,0.059],[0,0.071],[0.042,0.057],[0,0],[0,0],[0.024,0.067],[0.058,0.041],[0.071,0],[0.058,-0.041],[0,0],[0,0],[0.065,-0.025]],"v":[[2.938,0.175],[3,-0.019],[2.937,-0.213],[2.777,-0.34],[0.975,-0.98],[0.331,-2.77],[0.202,-2.938],[0,-3],[-0.199,-2.937],[-0.322,-2.77],[-0.967,-0.98],[-2.769,-0.34],[-2.937,-0.212],[-3,-0.011],[-2.936,0.186],[-2.769,0.309],[-0.967,0.982],[-0.322,2.772],[-0.195,2.937],[0.004,3],[0.204,2.937],[0.331,2.772],[0.975,0.941],[2.777,0.301]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.043137256056,0.631372570992,0.419607847929,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[600,600],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.2],"y":[0]},"t":0,"s":[90]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.2],"y":[0]},"t":30,"s":[0]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.2],"y":[0]},"t":60,"s":[0]},{"t":90,"s":[90]}],"ix":10},"p":{"a":0,"k":[456,12,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.2,0.2,0.2],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.2,0.2,0.2],"y":[0,0,0]},"t":30,"s":[100,100,100]},{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.2,0.2,0.2],"y":[0,0,0]},"t":60,"s":[100,100,100]},{"t":90,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.027,0.038],[0,0.046],[0.026,0.038],[0.043,0.017],[0,0],[0,0],[0.04,0.027],[0.048,0],[0.039,-0.028],[0.015,-0.045],[0,0],[0,0],[0.028,-0.039],[0,-0.048],[-0.028,-0.038],[-0.045,-0.015],[0,0],[0,0],[-0.039,-0.027],[-0.048,0],[-0.039,0.027],[-0.016,0.044],[0,0],[0,0]],"o":[[0.027,-0.038],[-0.001,-0.046],[-0.026,-0.038],[0,0],[0,0],[-0.016,-0.045],[-0.04,-0.027],[-0.047,0],[-0.039,0.028],[0,0],[0,0],[-0.045,0.016],[-0.028,0.039],[0,0.047],[0.028,0.038],[0,0],[0,0],[0.016,0.044],[0.039,0.027],[0.048,0],[0.039,-0.027],[0,0],[0,0],[0.044,-0.017]],"v":[[1.959,0.117],[2,-0.013],[1.958,-0.142],[1.851,-0.226],[0.65,-0.653],[0.22,-1.847],[0.135,-1.958],[0,-2],[-0.132,-1.958],[-0.215,-1.847],[-0.645,-0.653],[-1.846,-0.226],[-1.958,-0.141],[-2,-0.007],[-1.958,0.124],[-1.846,0.206],[-0.645,0.655],[-0.215,1.848],[-0.13,1.958],[0.003,2],[0.136,1.958],[0.22,1.848],[0.65,0.628],[1.851,0.201]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.043137256056,0.631372570992,0.419607847929,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[600,600],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120,"st":0,"bm":0}],"markers":[]}');
;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/Web.tsx










var LOTTIE_TAB_ANIMATION = "lottie-tab-animation";
function Web(param) {
    var streamType = param.streamType, hasDefaultTab = param.hasDefaultTab, _isSelfStream = param.isSelfStream, isSelfStream = _isSelfStream === void 0 ? false : _isSelfStream;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref1 = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl), category = ref1.filterParams.category, hasNewResearch = ref1.hasNewResearch;
    var hideFromMYUser = [
        "news",
        "reports",
        "research",
        "insider"
    ];
    var streamCategories = (0,react.useMemo)(function() {
        var listCategories = (0,utils/* getStreamCategories */.a9)(streamType);
        if (country === "MY") {
            listCategories = listCategories.filter(function(item) {
                return !hideFromMYUser.includes(item.key);
            });
        }
        if (streamType === constants/* STREAM_TYPE.USER */.R5.USER && !isSelfStream) {
            var result = listCategories.filter(function(item) {
                return item.key !== "notes";
            });
            return result;
        }
        return listCategories;
    }, [
        streamType,
        isSelfStream
    ]);
    var handleChangeCategory = function(key) {
        dispatch(// @ts-ignore
        StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam({
            category: key
        }));
        // destroy lottie when click research tab
        if (hasNewResearch && key === "research") {
            dispatch(StreamWidget_slice/* default.actions.removeHasNewResearch */.ZP.actions.removeHasNewResearch());
            lottie_default().destroy(LOTTIE_TAB_ANIMATION);
        }
        // if set to persist previous tab, set localstorage upon change tab
        if (hasDefaultTab) {
            localStorage.setItem(constants/* STREAM_STATE.CATEGORY */.eB.CATEGORY, key);
        }
    };
    (0,react.useEffect)(function() {
        lottie_default().loadAnimation({
            name: LOTTIE_TAB_ANIMATION,
            container: document.getElementById("navtab-research"),
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: lottie_euforia_namespaceObject
        });
        return function() {
            lottie_default().destroy(LOTTIE_TAB_ANIMATION);
        };
    }, [
        hasNewResearch,
        category
    ]);
    var showResearchIndicator = hasNewResearch && category !== "research";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WebContainer, {
        children: streamCategories.map(function(param) {
            var label = param.label, key = param.key, dataCy = param.dataCy;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamTypeWeb, {
                active: category === key,
                onClick: function() {
                    return handleChangeCategory(key);
                },
                style: {
                    position: "relative"
                },
                "data-cy": dataCy,
                children: [
                    label,
                    key === "research" && showResearchIndicator && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        id: "navtab-".concat(key),
                        style: {
                            position: "absolute",
                            top: -4,
                            left: 0,
                            width: "72px"
                        }
                    })
                ]
            }, key);
        })
    });
}
/* harmony default export */ var Navigation_Web = (Web);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/NavigationDropdown.tsx








var NavigationDropdown_Text = ui/* Common.Text */.Gn.Text, IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function NavigationDropdown(_param) {
    var _children = _param.children, children = _children === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}) : _children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationDropdown_Text, {
                as: "button",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                padding: "0 5px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/widget-trending/arrow-down.svg"
                })
            })
        ]
    }));
}
/* harmony default export */ var Navigation_NavigationDropdown = (NavigationDropdown);

// EXTERNAL MODULE: ./src/global/StreamWidget/Navigation/NavigationTab/__tests__/constant.ts
var constant = __webpack_require__(41351);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/Mobile.tsx













var Popover = ui/* Common.Popover */.Gn.Popover;
var Mobile_LOTTIE_TAB_ANIMATION = "lottie-tab-animation-mobile";
function Mobile(param) {
    var streamType = param.streamType, hasDefaultTab = param.hasDefaultTab, _isSelfStream = param.isSelfStream, isSelfStream = _isSelfStream === void 0 ? false : _isSelfStream;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl), category = ref.filterParams.category, hasNewResearch = ref.hasNewResearch;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref1.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var hideFromMYUser = [
        "news",
        "reports",
        "research",
        "insider"
    ];
    var streamCategories = (0,react.useMemo)(function() {
        var listCategories = (0,utils/* getStreamCategories */.a9)(streamType);
        if (country === "MY") {
            listCategories = listCategories.filter(function(item) {
                return !hideFromMYUser.includes(item.key);
            });
        }
        if (streamType === constants/* STREAM_TYPE.USER */.R5.USER && !isSelfStream) {
            var result = listCategories.filter(function(item) {
                return item.key !== "notes";
            });
            return result;
        }
        return listCategories;
    }, [
        streamType,
        isSelfStream
    ]);
    var ref2 = (0,utils/* getActiveCategory */.sw)(category, streamCategories), activeCategory = ref2.label;
    var handleChangeCategory = function(key) {
        dispatch(// @ts-ignore
        StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam({
            category: key
        }));
        // destroy lottie when click research tab
        if (hasNewResearch && key === "research") {
            dispatch(StreamWidget_slice/* default.actions.removeHasNewResearch */.ZP.actions.removeHasNewResearch());
            lottie_default().destroy(Mobile_LOTTIE_TAB_ANIMATION);
            document.getElementById("navtab-mobile-research").remove();
        }
        if (hasDefaultTab) {
            localStorage.setItem(constants/* STREAM_STATE.CATEGORY */.eB.CATEGORY, key);
        }
    };
    (0,react.useEffect)(function() {
        lottie_default().loadAnimation({
            name: Mobile_LOTTIE_TAB_ANIMATION,
            container: document.getElementById("navtab-mobile-research"),
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: lottie_euforia_namespaceObject
        });
        return function() {
            lottie_default().destroy(Mobile_LOTTIE_TAB_ANIMATION);
        };
    }, [
        hasNewResearch,
        category
    ]);
    var showResearchIndicator = hasNewResearch && category !== "research";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover, {
            content: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContainer, {
                    children: streamCategories.map(function(param) {
                        var label = param.label, key = param.key, dataCy = param.dataCy;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownOption, {
                            onClick: function() {
                                return handleChangeCategory(key);
                            },
                            style: {
                                position: "relative"
                            },
                            "data-cy": dataCy,
                            children: [
                                label,
                                key === "research" && showResearchIndicator && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    id: "navtab-mobile-".concat(key),
                                    style: {
                                        position: "absolute",
                                        top: 0,
                                        left: -4,
                                        width: "72px"
                                    }
                                })
                            ]
                        }, key);
                    })
                });
            },
            trigger: "click",
            placement: "bottomLeft",
            overlayInnerStyle: {
                borderRadius: "4px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_NavigationDropdown, {
                "data-cy": constant/* DATA_CY_DROPDOWN_STREAM_ACTIVE */.MF,
                children: activeCategory
            })
        })
    });
}
/* harmony default export */ var Navigation_Mobile = (Mobile);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/Filter.tsx










var Filter_Popover = ui/* Common.Popover */.Gn.Popover;
function Filter() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl), type = ref1.filterParams.type;
    var ref2 = (0,utils/* getActiveCategory */.sw)(type, constants/* streamTypes */.J1), activeFilterLabel = ref2.label, activeKey = ref2.key;
    var handleChangeFilter = function(key, lsKey) {
        dispatch(// @ts-ignore
        StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam({
            type: key,
            keyword: ""
        }));
        localStorage.setItem(constants/* STREAM_STATE.TYPE */.eB.TYPE, lsKey);
        setVisible(false);
    };
    var handleVisibleChange = function(newOpen) {
        setVisible(newOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_Popover, {
        content: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownWrapper, {
                children: constants/* streamTypes.map */.J1.map(function(param) {
                    var label = param.label, key = param.key, lsKey = param.lsKey, dataCy = param.dataCy;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownOption, {
                        onClick: function() {
                            return handleChangeFilter(key, lsKey);
                        },
                        active: key === activeKey,
                        "data-cy": dataCy,
                        children: label
                    }, key);
                })
            });
        },
        trigger: "click",
        placement: "bottomRight",
        visible: visible,
        onVisibleChange: handleVisibleChange,
        overlayInnerStyle: {
            borderRadius: "4px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_NavigationDropdown, {
            "data-cy": constant/* DATA_CY_DROPDOWN_STREAM_ACTIVE */.MF,
            children: activeFilterLabel
        })
    });
}
/* harmony default export */ var Navigation_Filter = (Filter);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/FilterReportType.tsx










var FilterReportType_Popover = ui/* Common.Popover */.Gn.Popover;
function FilterReportType() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl), reporttype = ref1.filterParams.reporttype;
    var handleChange = function(key) {
        dispatch(// @ts-ignore
        StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam({
            reporttype: key
        }));
        setVisible(false);
    };
    var handleVisibleChange = function(newOpen) {
        setVisible(newOpen);
    };
    var ref2 = (0,utils/* getActiveReportType */.TL)(reporttype), activeReportType = ref2.label, activeKey = ref2.key;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterReportType_Popover, {
        content: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownWrapper, {
                children: constants/* reportCategories.map */.U1.map(function(param) {
                    var label = param.label, key = param.key;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownOption, {
                        onClick: function() {
                            return handleChange(key);
                        },
                        active: key === activeKey,
                        children: label
                    }, key);
                })
            });
        },
        trigger: "click",
        placement: "bottomRight",
        visible: visible,
        onVisibleChange: handleVisibleChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_NavigationDropdown, {
            "data-cy": constant/* DATA_CY_DROPDOWN_STREAM_REPORT_ACTIVE */.xB,
            children: activeReportType
        })
    });
}
/* harmony default export */ var Navigation_FilterReportType = (FilterReportType);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/SearchAdvanced.tsx








var SearchAdvanced_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, SearchAdvanced_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, SearchAdvanced_Flex = ui/* Common.Flex */.Gn.Flex, SearchAdvanced_Text = ui/* Common.Text */.Gn.Text, Button = ui/* Common.Button */.Gn.Button;
function SearchAdvanced(param) {
    var isActive = param.isActive, onSearch = param.onSearch, tabHeaderLabel = param.tabHeaderLabel;
    var ref = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl), _filterParams = ref.filterParams, defaultKeyword = _filterParams.keyword;
    var inputRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isAdvancedSearchVisible = ref1[0], setAdvancedSearchVisible = ref1[1];
    var ref2 = (0,react.useState)(""), keyword = ref2[0], setKeyword = ref2[1];
    var ref3 = (0,react.useState)(null), from = ref3[0], setFrom = ref3[1];
    var ref4 = (0,react.useState)(null), to = ref4[0], setTo = ref4[1];
    var handleSubmit = function(e) {
        var data = {
            keyword: keyword,
            from: "",
            to: ""
        };
        if (isAdvancedSearchVisible) {
            if (from) {
                data.from = moment_default()(from, "YYYY-MM-DD").format("YYYY-MM-DD");
            }
            if (to) {
                data.to = moment_default()(to, "YYYY-MM-DD").format("YYYY-MM-DD");
            }
        }
        onSearch(data);
        e.preventDefault();
    };
    var onChangeKeyword = function(e) {
        var value = e.currentTarget.value;
        if (!value) {
            onSearch({
                keyword: "",
                from: "",
                to: ""
            });
        }
        setKeyword(value);
    };
    var onClickAdvancedSearchIcon = function() {
        return setAdvancedSearchVisible(!isAdvancedSearchVisible);
    };
    (0,react.useEffect)(function() {
        if (!isActive || !inputRef || !inputRef.current) {
            return;
        }
        inputRef.current.focus({
            cursor: "start"
        });
    }, [
        isActive
    ]);
    (0,react.useEffect)(function() {
        setKeyword(defaultKeyword);
    }, [
        defaultKeyword
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                    placeholder: "Search ".concat(tabHeaderLabel, "..."),
                    width: "100%",
                    value: keyword,
                    onChange: onChangeKeyword,
                    onPressEnter: handleSubmit,
                    allowClear: true,
                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAdvanced_IconWrapper, {
                        size: "16px",
                        onClick: onClickAdvancedSearchIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAdvanced_Iconmoon, {
                            className: "icon-toolbar_filter",
                            size: "16px"
                        })
                    }),
                    "data-cy": constant/* DATA_CY_SEARCH_STREAM_MENU_SEARCH */.UL,
                    ref: inputRef
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSearchWrapper, {
                    active: isAdvancedSearchVisible,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAdvanced_Text, {
                            family: "bold",
                            height: "30px",
                            children: "Advanced Search"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchAdvanced_Flex, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAdvanced_Text, {
                                    children: "Search"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDate, {
                                    placeholder: "From",
                                    value: from,
                                    onChange: setFrom,
                                    suffixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    format: "YYYY-MM-DD",
                                    "data-cy": constant/* DATA_CY_SEARCH_STREAM_FILTER_FROM */.Ox
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDate, {
                                    placeholder: "To",
                                    value: to,
                                    onChange: setTo,
                                    suffixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    format: "YYYY-MM-DD",
                                    "data-cy": constant/* DATA_CY_SEARCH_STREAM_FILTER_TO */.bJ
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    type: "primary",
                                    htmlType: "submit",
                                    height: "30px",
                                    ml: "10px",
                                    "data-cy": constant/* DATA_CY_SEARCH_STREAM_SUBMIT */.h$,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAdvanced_Text, {
                                        color: "inherit",
                                        children: "Search"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "submit",
                    style: {
                        display: "none"
                    }
                })
            ]
        })
    });
}
/* harmony default export */ var Navigation_SearchAdvanced = (SearchAdvanced);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/DateSwitcher.tsx






var DateSwitcher_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, DateSwitcher_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, DateSwitcher_Flex = ui/* Common.Flex */.Gn.Flex, DateSwitcher_Text = ui/* Common.Text */.Gn.Text;
var NORMAL_DATE_FORMAT = "YYYY-MM-DD";
function DateSwitcher() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var filterParams = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl).filterParams;
    var defaultDate = moment_default()().format(NORMAL_DATE_FORMAT);
    var currentDate = filterParams.date || defaultDate;
    var handlePrevDate = function() {
        var prevDate = moment_default()(currentDate).subtract(1, "days").format(NORMAL_DATE_FORMAT);
        dispatch(// @ts-ignore
        StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam({
            date: prevDate
        }));
        localStorage.setItem(constants/* LS_STREAM_TRENDING_TAB_DATE */.oE, prevDate);
    };
    var handleNextDate = function() {
        var nextDate = moment_default()(currentDate).add(1, "days").format(NORMAL_DATE_FORMAT);
        dispatch(// @ts-ignore
        StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam({
            date: nextDate
        }));
        localStorage.setItem(constants/* LS_STREAM_TRENDING_TAB_DATE */.oE, nextDate);
    };
    var isShowNextDate = moment_default()(currentDate).format(NORMAL_DATE_FORMAT) < moment_default()().format(NORMAL_DATE_FORMAT);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DateSwitcher_Flex, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSwitcher_IconWrapper, {
                onClick: handlePrevDate,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSwitcher_Iconmoon, {
                    className: "icon-toolbar_prev",
                    size: "16px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSwitcher_Text, {
                as: "span",
                mx: "12px",
                children: moment_default()(currentDate).format("dddd, MMMM DD YYYY")
            }),
            isShowNextDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSwitcher_IconWrapper, {
                onClick: handleNextDate,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSwitcher_Iconmoon, {
                    className: "icon-toolbar_next",
                    size: "16px"
                })
            })
        ]
    });
}
/* harmony default export */ var Navigation_DateSwitcher = (DateSwitcher);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/SelectReportType.tsx





var Select = ui/* Common.Select */.Gn.Select;
function SelectReportType() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var filterParams = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl).filterParams;
    var handleChange = function(key) {
        dispatch(// @ts-ignore
        StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam({
            reporttype: key
        }));
    };
    var activeReportType = filterParams.reporttype || constants/* reportCategories.0.key */.U1[0].key;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
        value: activeReportType,
        onChange: handleChange,
        style: {
            width: "100%"
        },
        children: constants/* reportCategories.map */.U1.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Option, {
                value: category.key,
                children: category.label
            }, category.key);
        })
    });
}
/* harmony default export */ var Navigation_SelectReportType = (SelectReportType);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/NavigationTab/index.tsx








var NavigationTab_Flex = ui/* Common.Flex */.Gn.Flex, NavigationTab_Text = ui/* Common.Text */.Gn.Text;
function NavigationTab(param) {
    var selectedTab = param.selectedTab, setSelectedTab = param.setSelectedTab, _persistTab = param.persistTab, persistTab = _persistTab === void 0 ? false : _persistTab, isNotified = param.isNotified, removeNewIndicator = param.removeNewIndicator;
    var ref = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl), hasNewResearch = ref.hasNewResearch, newResearchCount = ref.newResearchCount;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref1.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var handleTabChange = function(item) {
        setSelectedTab(item.value);
        if (item.value === "research") {
            removeNewIndicator();
        }
        if (persistTab) {
            localStorage.setItem(constants/* STREAM_STATE.TAB */.eB.TAB, item.value);
        }
    };
    var streamTabs = country === "MY" ? constants/* STREAM_TABS_MY */.PA : constants/* STREAM_TABS */.q1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationTab_Flex, {
            align: "center",
            justify: "flex-start",
            height: "100%",
            style: {
                gap: "16px"
            },
            children: streamTabs.map(function(tab) {
                var active = selectedTab === tab.value;
                var suffix = active ? "-active" : "";
                var textColor = active ? ui/* color.primary */.$_.primary : ui/* color.highgray */.$_.highgray;
                var border = active && "solid 1px ".concat(ui/* color.primary */.$_.primary);
                var showIndicator = tab.value === "research" && hasNewResearch && newResearchCount > 0 && selectedTab !== tab.value && !isNotified;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationTab_Flex, {
                    align: "center",
                    style: {
                        gap: "8px",
                        cursor: "pointer",
                        borderBottom: border,
                        position: "relative"
                    },
                    onClick: function() {
                        return handleTabChange(tab);
                    },
                    height: "100%",
                    padding: "0 6px",
                    "data-cy": tab.dataCy,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "".concat(tab.icon).concat(suffix, ".svg")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationTab_Text, {
                            color: textColor,
                            family: active && "bold",
                            children: tab.label
                        }),
                        showIndicator && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIndicator, {
                            larger: newResearchCount > 99,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: newResearchCount > 99 ? "99+" : newResearchCount
                            })
                        })
                    ]
                }, tab.value);
            })
        })
    });
}
/* harmony default export */ var Navigation_NavigationTab = (NavigationTab);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/NavigationTab/ResearchBox.tsx




var ResearchBox_Flex = ui/* Common.Flex */.Gn.Flex, ResearchBox_Text = ui/* Common.Text */.Gn.Text;
var itemList = [
    {
        label: "Academy",
        icon: "academy",
        bgColor: "rgb(239, 247, 252)",
        link: "/academy"
    },
    {
        label: "Unboxing",
        icon: "unboxing",
        bgColor: "rgb(235, 249, 247)",
        link: "/academy/unboxing"
    },
    {
        label: "Events",
        icon: "events",
        bgColor: "rgb(242, 241, 254)",
        link: "/stream/event"
    },
    {
        label: "Snips",
        icon: "snips",
        bgColor: "rgb(242, 246, 232)",
        link: "/stream/snips"
    }, 
];
function ResearchBox() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchBox_Flex, {
        justify: "center",
        padding: "20px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchBox_Flex, {
            align: "center",
            justify: "space-between",
            style: {
                width: "100%",
                maxWidth: "468px"
            },
            children: itemList.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "".concat(item.link, "?source=research"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer noopener",
                        id: item.label,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResearchBox_Flex, {
                            direction: "column",
                            align: "center",
                            style: {
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchBox_Flex, {
                                    align: "center",
                                    justify: "center",
                                    style: {
                                        width: 60,
                                        height: 60,
                                        borderRadius: "999px",
                                        backgroundColor: item.bgColor
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/research-stream/header-".concat(item.icon, ".svg")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchBox_Text, {
                                    align: "center",
                                    color: ui/* color.highgray */.$_.highgray,
                                    children: item.label
                                })
                            ]
                        })
                    })
                });
            })
        })
    });
}
/* harmony default export */ var NavigationTab_ResearchBox = (ResearchBox);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/__tests__/constant.ts
var DATA_CY_STREAM_WIDGET_NAVIGATION = "stream-widget-navigation";

;// CONCATENATED MODULE: ./src/global/StreamWidget/Navigation/index.tsx






















var Navigation_Flex = ui/* Common.Flex */.Gn.Flex, Navigation_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, Navigation_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function Navigation(param) {
    var _streamType = param.streamType, streamType = _streamType === void 0 ? constants/* STREAM_TYPE.GENERIC */.R5.GENERIC : _streamType, _hasDefaultTab = param.hasDefaultTab, hasDefaultTab = _hasDefaultTab === void 0 ? false : _hasDefaultTab, _symbol = param.symbol, symbol = _symbol === void 0 ? null : _symbol, _isSelfStream = param.isSelfStream, isSelfStream = _isSelfStream === void 0 ? false : _isSelfStream;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl), _filterParams = ref.filterParams, keyword = _filterParams.keyword, type = _filterParams.type, category = _filterParams.category, tabHeader = ref.tabHeader;
    var ref1 = (0,react.useState)(false), isSearchVisible = ref1[0], setSearchVisible = ref1[1];
    var ref2 = (0,react.useState)(false), isNotified = ref2[0], setIsNotified = ref2[1];
    var _STREAM_TABS = (0,_sliced_to_array/* default */.Z)(constants/* STREAM_TABS */.q1, 3), STREAM = _STREAM_TABS[0], _NEWS = _STREAM_TABS[1], RESEARCH = _STREAM_TABS[2];
    var mappedFilter = constants/* streamTypes.map */.J1.map(function(item) {
        return item.key;
    });
    var isReports = category === "reports";
    var showSelectReport = isReports && streamType !== constants/* STREAM_TYPE.GENERIC */.R5.GENERIC;
    var showFilter = (0,_to_consumable_array/* default */.Z)(mappedFilter).includes(type) && !isReports;
    var handleSearch = function(val) {
        dispatch(StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam((0,_object_spread/* default */.Z)({}, val)));
    };
    var handleSelectTab = function(value) {
        // @ts-ignore
        dispatch(StreamWidget_slice/* default.actions.setTabHeader */.ZP.actions.setTabHeader(value));
    };
    var handleGetResearchIndicator = function() {
        dispatch(StreamWidget_slice/* effects.getResearchIndicator */.Sz.getResearchIndicator(symbol));
    };
    var removeNewIndicator = function() {
        setIsNotified(true);
    };
    var toggleSearch = function() {
        setSearchVisible(function(prev) {
            return !prev;
        });
    };
    (0,react.useEffect)(function() {
        handleGetResearchIndicator();
    }, []);
    (0,react.useEffect)(function() {
        if (!isSearchVisible) {
            // if closing search params and there's keyword, reset search
            if (keyword) {
                var data = {
                    keyword: "",
                    from: "",
                    to: ""
                };
                // @ts-ignore
                dispatch(StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam((0,_object_spread/* default */.Z)({}, data)));
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        isSearchVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationContainer, {
        streamType: streamType,
        category: category,
        "data-cy": DATA_CY_STREAM_WIDGET_NAVIGATION,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorHandlers_If/* default */.Z, {
                condition: streamType === constants/* STREAM_TYPE.GENERIC */.R5.GENERIC,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationTabContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_NavigationTab, {
                            selectedTab: tabHeader,
                            setSelectedTab: handleSelectTab,
                            persistTab: hasDefaultTab,
                            isNotified: isNotified,
                            removeNewIndicator: removeNewIndicator
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_Flex, {
                            pl: "4px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_IconWrapper, {
                                onClick: toggleSearch,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_Iconmoon, {
                                    className: "icon-avatar_search",
                                    color: isSearchVisible ? ui/* color.primary */.$_.primary : undefined,
                                    "data-cy": constant/* DATA_CY_SEARCH_STREAM_MENU_FILTER */.tx
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorHandlers_If/* default */.Z, {
                condition: tabHeader === STREAM.value,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamMenuContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorHandlers_If/* default */.Z, {
                            condition: type !== "trending",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_Web, {
                                        streamType: streamType,
                                        hasDefaultTab: hasDefaultTab,
                                        isSelfStream: isSelfStream
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_Mobile, {
                                        streamType: streamType,
                                        hasDefaultTab: hasDefaultTab,
                                        isSelfStream: isSelfStream
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorHandlers_If/* default */.Z, {
                            condition: type === "trending",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_DateSwitcher, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navigation_Flex, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorHandlers_If/* default */.Z, {
                                    condition: streamType === constants/* STREAM_TYPE.GENERIC */.R5.GENERIC,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorHandlers_If/* default */.Z, {
                                            condition: showFilter && category === "ideas",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_Filter, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorHandlers_If/* default */.Z, {
                                            condition: isReports,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_FilterReportType, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorHandlers_If/* default */.Z, {
                                    condition: streamType !== constants/* STREAM_TYPE.GENERIC */.R5.GENERIC && category !== "notes",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_Flex, {
                                        pl: "20px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_IconWrapper, {
                                            onClick: toggleSearch,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_Iconmoon, {
                                                className: "icon-avatar_search",
                                                "data-cy": "".concat(constant/* DATA_CY_SEARCH_STREAM_MENU */.hL, "-").concat(streamType)
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorHandlers_If/* default */.Z, {
                condition: category !== "notes",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBoxContainer, {
                    active: isSearchVisible,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_SearchAdvanced, {
                        isActive: isSearchVisible,
                        onSearch: handleSearch,
                        tabHeaderLabel: tabHeader
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBoxContainer, {
                active: showSelectReport && !isSearchVisible,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_SelectReportType, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorHandlers_If/* default */.Z, {
                condition: tabHeader === RESEARCH.value && streamType === constants/* STREAM_TYPE.GENERIC */.R5.GENERIC,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationTab_ResearchBox, {})
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_Navigation = (Navigation);

// EXTERNAL MODULE: ./src/global/StreamWidget/styled.ts
var StreamWidget_styled = __webpack_require__(59007);
// EXTERNAL MODULE: ./src/global/StreamConversation/index.tsx + 25 modules
var StreamConversation = __webpack_require__(72857);
// EXTERNAL MODULE: ./src/global/StreamWidget/EmptyState/index.tsx
var EmptyState = __webpack_require__(21776);
;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/__tests__/constant.ts
var TEST_CASE_MESSAGE_COMPONENTS = function(comp) {
    return {
        SHOULD_RENDER_SUCCESSFULLY: "Component ".concat(comp, " in Suggested Stream Widget Feature should render successfully")
    };
};
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_INDEX = "suggested-people-stream-widget-index";
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_HEADER = "suggested-people-stream-widget-header";
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_HEADER_ACTION = "suggested-people-stream-widget-header-action";
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_LOADING = "suggested-people-stream-widget-loading";
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_NAVIGATION_NEXT = "suggested-people-stream-widget-swiper-navigation-next";
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_NAVIGATION_PREV = "suggested-people-stream-widget-swiper-navigation-prev";
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_CONTAINER = "suggested-people-stream-widget-swiper-container";
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SUGGESTED_ITEM_INDEX = "suggested-people-stream-widget-suggested-item-index";
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SUGGESTED_ITEM_FOLLOW = "suggested-people-stream-widget-suggested-item-follow";
var DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SUGGESTED_ITEM_REMOVE = "suggested-people-stream-widget-suggested-item-remove";

;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/Header.tsx




var Header_Flex = ui/* Common.Flex */.Gn.Flex, Header_Text = ui/* Common.Text */.Gn.Text;
function Header_Header() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
        justify: "space-between",
        mb: "16px",
        "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_HEADER,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Text, {
                family: "bold",
                size: "16px",
                children: "Suggestion For You"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    pathname: "/discover/people",
                    query: {
                        tab_selected: "all"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Text, {
                    color: ui/* color.primary */.$_.primary,
                    as: "a",
                    "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_HEADER_ACTION,
                    children: "See All"
                })
            })
        ]
    });
}
/* harmony default export */ var SuggestedPeopleWidget_Header = (Header_Header);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/styled.ts

function SuggestedPeopleWidget_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n\n  .slick-disabled {\n    opacity: 0% !important;\n  }\n"
    ]);
    SuggestedPeopleWidget_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SuggestedPeopleWidget_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 163px;\n"
    ]);
    SuggestedPeopleWidget_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SuggestedPeopleWidget_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 16px;\n  height: 217px;\n  position: relative;\n  cursor: pointer;\n"
    ]);
    SuggestedPeopleWidget_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SuggestedPeopleWidget_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: ",
        ";\n    position: absolute;\n    z-index : 2;\n    top: 75px;\n"
    ]);
    SuggestedPeopleWidget_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SuggestedPeopleWidget_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n"
    ]);
    SuggestedPeopleWidget_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SuggestedPeopleWidget_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  right: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n"
    ]);
    SuggestedPeopleWidget_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SuggestedPeopleWidget_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 290px;\n  border-bottom: solid 1px ",
        ";\n  padding: 16px 20px;\n"
    ]);
    SuggestedPeopleWidget_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SuggestedPeopleWidget_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 10px;\n  right: 10px;\n"
    ]);
    SuggestedPeopleWidget_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SuggestedPeopleWidget_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: -20px;\n  height: 16px;\n  width: 16px;\n"
    ]);
    SuggestedPeopleWidget_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-slide {\n    width: 175px !important;\n    margin-right: 12px;\n  }\n\n  .slick-track {\n    display: flex !important;\n  }\n"
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var SuggestedPeopleWidget_styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_Button = ui/* Common.Button */.Gn.Button, styled_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1ca7ae10-0"
})(SuggestedPeopleWidget_styled_templateObject(), ui/* color.light */.$_.light);
var BoxWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1ca7ae10-1"
})(SuggestedPeopleWidget_styled_templateObject1());
var BoxContainer = (0,styled_components_browser_esm["default"])(SuggestedPeopleWidget_styled_Flex).attrs({
    direction: "column",
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-1ca7ae10-2"
})(SuggestedPeopleWidget_styled_templateObject2(), ui/* color.light */.$_.light, ui/* color.downgray */.$_.downgray);
var styled_Navigation = (0,styled_components_browser_esm["default"])(styled_Button).attrs({
    p: "0"
}).withConfig({
    shouldForwardProp: function(props) {
        return ![
            "isVisible"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        height: "40px",
        padding: "5px",
        isVisible: props.isVisible
    };
}).withConfig({
    componentId: "sc-1ca7ae10-3"
})(SuggestedPeopleWidget_styled_templateObject3(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? 1 : 0;
});
var PrevButton = (0,styled_components_browser_esm["default"])(styled_Navigation).withConfig({
    componentId: "sc-1ca7ae10-4"
})(SuggestedPeopleWidget_styled_templateObject4());
var NextButton = (0,styled_components_browser_esm["default"])(styled_Navigation).withConfig({
    componentId: "sc-1ca7ae10-5"
})(SuggestedPeopleWidget_styled_templateObject5());
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1ca7ae10-6"
})(SuggestedPeopleWidget_styled_templateObject6(), ui/* color.gainsboro */.$_.gainsboro);
var CloseIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1ca7ae10-7"
})(SuggestedPeopleWidget_styled_templateObject7());
var CloseIcon = (0,styled_components_browser_esm["default"])(styled_Iconmoon).attrs({
    className: "icon-widget_close"
}).withConfig({
    componentId: "sc-1ca7ae10-8"
})(SuggestedPeopleWidget_styled_templateObject8());
var Slider = (0,styled_components_browser_esm["default"])(lib/* default */.Z).withConfig({
    componentId: "sc-1ca7ae10-9"
})(styled_templateObject9());


// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/constants.ts
var FOLLOW_ACTION = {
    FOLLOW: "FOLLOW",
    UNFOLLOW: "UNFOLLOW"
};
var QUERY_KEY_DATA = {
    suggested: "getSuggestFriendsStreamWidget"
};
var USER_SUGGESTED_FILTER = {
    FILTER_UNSPECIFIED: "FILTER_UNSPECIFIED",
    FILTER_ALL: "FILTER_ALL",
    FILTER_STREAM: "FILTER_STREAM",
    FILTER_ONBOARDING: "FILTER_ONBOARDING"
};
var SWIPER_PARAMS = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    arrows: true,
    responsive: [
        {
            breakpoint: 720,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 425,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, 
    ]
};

// EXTERNAL MODULE: ./src/lib/api/friends.ts
var friends = __webpack_require__(63699);
// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/helper.ts
// APIs





var getSuggestedPeople = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return friends/* default.getSuggestFriends */.Z.getSuggestFriends({
                        page: 1,
                        limit: 30,
                        filter: USER_SUGGESTED_FILTER.FILTER_UNSPECIFIED
                    });
                case 2:
                    data = _ctx.sent.data;
                    if (!(!data || data.error)) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Attempt to get suggested people failed!");
                case 5:
                    return _ctx.abrupt("return", (data === null || data === void 0 ? void 0 : data.data) || []);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSuggestedPeople() {
        return _ref.apply(this, arguments);
    };
}();
var followUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var userid, type, targetAPI, response, _data, error, message, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    userid = param.userid, type = param.type;
                    if (userid) {
                        _ctx.next = 3;
                        break;
                    }
                    throw new Error("User id is empty");
                case 3:
                    targetAPI = watchlist/* default.postFollowUser */.Z.postFollowUser;
                    if (type === FOLLOW_ACTION.UNFOLLOW) {
                        targetAPI = watchlist/* default.postUnfollowUser */.Z.postUnfollowUser;
                    }
                    _ctx.next = 7;
                    return targetAPI(userid);
                case 7:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 10;
                        break;
                    }
                    throw new Error("Attempt to follow user failed");
                case 10:
                    _data = response.data, error = _data.error_type, message = _data.message, data = _data.data;
                    if (!error) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: error,
                        message: message
                    });
                case 13:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message,
                        type: type,
                        userid: userid
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function followUser(_) {
        return _ref.apply(this, arguments);
    };
}();
var deleteSuggestedItem = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", body.id);
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteSuggestedItem(body) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/SuggestedItem.tsx
/* eslint-disable no-nested-ternary */ 


















var SuggestedItem_Flex = ui/* Common.Flex */.Gn.Flex, SuggestedItem_Text = ui/* Common.Text */.Gn.Text, Avatar = ui/* Common.Avatar */.Gn.Avatar, SuggestedItem_Button = ui/* Common.Button */.Gn.Button;
function SuggestedItem(props) {
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var isFollowed = props.isFollowed, reason = props.reason, _user = props.user, userid = _user.userid, username = _user.username, avatar = _user.user_avatar, isVerified = _user.is_verified, index = props.index, restUserProps = (0,_object_without_properties/* default */.Z)(props.user, [
        "userid",
        "username",
        "user_avatar",
        "is_verified"
    ]);
    var avatarSrc = "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    var followMutation = (0,useMutation/* useMutation */.D)({
        mutationKey: [
            QUERY_KEY_DATA.suggested
        ],
        mutationFn: followUser,
        onSuccess: function(_, variables) {
            return queryClient.setQueryData([
                QUERY_KEY_DATA.suggested
            ], function(oldData) {
                var updatedUserId = variables.userid, updatedType = variables.type;
                var newArr = oldData.map(function(data) {
                    if (Number(data.user.userid) === Number(updatedUserId)) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            user: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.user), {
                                follow: updatedType === FOLLOW_ACTION.FOLLOW
                            })
                        });
                    }
                    return data;
                });
                setLoading(false);
                return newArr;
            });
        }
    });
    var handleFollow = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var followType, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        followType = isFollowed ? FOLLOW_ACTION.UNFOLLOW : FOLLOW_ACTION.FOLLOW;
                        data = {
                            userid: userid,
                            type: followType
                        };
                        setLoading(true);
                        followMutation.mutate(data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFollow() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeMutation = (0,useMutation/* useMutation */.D)({
        mutationKey: [
            QUERY_KEY_DATA.suggested
        ],
        mutationFn: deleteSuggestedItem,
        onSuccess: function(_, variables) {
            return queryClient.setQueryData([
                QUERY_KEY_DATA.suggested
            ], function(oldData) {
                var id = variables.id;
                return oldData.filter(function(__, indexData) {
                    return indexData !== id;
                });
            });
        }
    });
    var removeItem = function() {
        removeMutation.mutate({
            id: index
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxWrapper, {
        "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SUGGESTED_ITEM_INDEX,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestedItem_Flex, {
                    direction: "column",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(username),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                size: "large",
                                padding: "0 0 12px",
                                as: "a",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: "",
                                    src: avatarSrc,
                                    onError: function(e) {
                                        return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(username),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestedItem_Flex, {
                                as: "a",
                                align: "center",
                                justify: "center",
                                mb: "4px",
                                target: "_blank",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedItem_Text, {
                                        family: "bold",
                                        size: "13px",
                                        ellipsis: true,
                                        align: "center",
                                        style: {
                                            maxWidth: "100px"
                                        },
                                        children: username
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                        deprecatedVerifiedStatus: isVerified,
                                        verifiedStatus: restUserProps === null || restUserProps === void 0 ? void 0 : restUserProps.verified_status
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedItem_Text, {
                            size: "13px",
                            height: "16px",
                            mb: "16px",
                            color: ui/* color.midgray */.$_.midgray,
                            align: "center",
                            children: reason
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedItem_Button, {
                    "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SUGGESTED_ITEM_FOLLOW,
                    disabled: loading,
                    type: isFollowed ? "default" : "primary",
                    block: true,
                    onClick: handleFollow,
                    radius: "4px",
                    height: "28px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedItem_Text, {
                        size: "13px",
                        color: isFollowed ? ui/* color.primary */.$_.primary : ui/* color.light */.$_.light,
                        align: "center",
                        family: "bold",
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {}) : isFollowed ? "Following" : "Follow"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {
                        onClick: removeItem,
                        "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SUGGESTED_ITEM_REMOVE
                    })
                })
            ]
        }))
    });
}
/* harmony default export */ var SuggestedPeopleWidget_SuggestedItem = (SuggestedItem);

// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/Loading.tsx





var Loading_Flex = ui/* Common.Flex */.Gn.Flex;
function Loading() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxContainer, {
        "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_LOADING,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Loading_Flex, {
                direction: "column",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Avatar */.Z.Avatar, {
                        active: true,
                        size: 70,
                        style: {
                            marginBottom: "8px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                        size: "small",
                        active: true,
                        style: {
                            width: 70,
                            height: 17
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                        size: "small",
                        active: true,
                        style: {
                            width: 90,
                            height: 14
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                size: "small",
                active: true,
                style: {
                    width: 70
                }
            })
        ]
    });
}
/* harmony default export */ var SuggestedPeopleWidget_Loading = (Loading);

;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/Hooks/useSuggestedPeopleWidget.ts



function useSuggestedPeopleWidget() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            QUERY_KEY_DATA.suggested
        ],
        queryFn: getSuggestedPeople,
        staleTime: 60 * 1000
    });
};

;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/SwiperContainer.tsx











var SwiperContainer_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function SwiperContainer() {
    var ref = (0,react.useState)(false), isNavVisible = ref[0], setVisibleNav = ref[1];
    var swiperRef = (0,react.useRef)(null);
    var ref1 = useSuggestedPeopleWidget(), isFetching = ref1.isFetching, data = ref1.data;
    var goNext = function() {
        swiperRef.current.slickNext();
    };
    var goPrev = function() {
        swiperRef.current.slickPrev();
    };
    var loadingData = new Array(4).fill(null).map(function(_, i) {
        return {
            id: i
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_CONTAINER,
        onMouseEnter: function() {
            return setVisibleNav(true);
        },
        onMouseLeave: function() {
            return setVisibleNav(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Slider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: function(slider) {
                swiperRef.current = slider;
            },
            nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                isVisible: isNavVisible,
                onClick: goNext,
                "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_NAVIGATION_NEXT,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperContainer_Iconmoon, {
                    className: "icon-toolbar_next"
                })
            }),
            prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {
                isVisible: isNavVisible,
                onClick: goPrev,
                "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_NAVIGATION_PREV,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperContainer_Iconmoon, {
                    className: "icon-toolbar_prev"
                })
            })
        }, SWIPER_PARAMS), {
            children: [
                isFetching && loadingData.map(function(arr) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedPeopleWidget_Loading, {}, arr.id);
                }),
                !isFetching && data && data.map(function(people, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedPeopleWidget_SuggestedItem, {
                        user: people.user,
                        isFollowed: people.user.follow,
                        reason: people.reason,
                        index: index
                    }, people.user.userid);
                })
            ]
        }))
    });
}
/* harmony default export */ var SuggestedPeopleWidget_SwiperContainer = (SwiperContainer);

;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/index.tsx
/* eslint-disable indent */ /* eslint-disable react/jsx-indent */ 





function SuggestedPeopleWidget() {
    var data = useSuggestedPeopleWidget().data;
    if ((data === null || data === void 0 ? void 0 : data.length) === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        "data-cy": DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_INDEX,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedPeopleWidget_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedPeopleWidget_SwiperContainer, {})
        ]
    });
}
/* harmony default export */ var global_SuggestedPeopleWidget = (SuggestedPeopleWidget);

;// CONCATENATED MODULE: ./src/global/StreamWidget/ResearchPost/styled.ts

function ResearchPost_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  border-bottom: solid 1px #f1f1f1;\n  cursor: pointer;\n  gap: 16px;\n  justify-content: space-between;\n  margin: 0 20px;\n\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    ResearchPost_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResearchPost_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f7f7f7;\n  border-radius: 4px;\n  height: 75px;\n  position: relative;\n  width: 100px;\n\n  img {\n    border-radius: 4px;\n    height: 100%;\n    object-fit: cover;\n    object-position: center top;\n    opacity: 1;\n    position: absolute;\n    width: 100%;\n  }\n\n  @media ",
        " {\n    height: 90px;\n    width: 120px;\n  }\n"
    ]);
    ResearchPost_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ResearchPost_styled_Flex = ui/* Common.Flex */.Gn.Flex;
var styled_ResearchBox = (0,styled_components_browser_esm["default"])(ResearchPost_styled_Flex).withConfig({
    componentId: "sc-84acd4cd-0"
})(ResearchPost_styled_templateObject());
var ResearchImage = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-84acd4cd-1"
})(ResearchPost_styled_templateObject1(), ui/* device.tablet */.Uh.tablet);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/PinnedLabel.tsx
var PinnedLabel = __webpack_require__(82592);
;// CONCATENATED MODULE: ./src/global/StreamWidget/ResearchPost/index.tsx





var ResearchPost_Flex = ui/* Common.Flex */.Gn.Flex, ResearchPost_Text = ui/* Common.Text */.Gn.Text;
function ResearchPost(param) {
    var post = param.post, _isPinned = param.isPinned, isPinned = _isPinned === void 0 ? false : _isPinned;
    var handleClick = function() {
        window.open(post.url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isPinned && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchPost_Flex, {
                pl: "20px",
                pt: "20px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedLabel/* default */.Z, {
                    marginBottom: "12px",
                    isCompanyPinnedPost: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_ResearchBox, {
                p: isPinned ? "" : "16px 0",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResearchPost_Flex, {
                        direction: "column",
                        align: "flex-start",
                        style: {
                            gap: "4px",
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchPost_Text, {
                                as: "h2",
                                size: isPinned ? "16px" : "18px",
                                family: "bold",
                                weight: 700,
                                height: "22px",
                                children: post.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResearchPost_Flex, {
                                align: "center",
                                style: {
                                    gap: "4px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: post.icon_url,
                                        style: {
                                            width: 16
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResearchPost_Text, {
                                        size: isPinned ? "12px" : "13px",
                                        color: ui/* color.highgray */.$_.highgray,
                                        height: "18px",
                                        children: [
                                            post.category_label,
                                            " • ",
                                            post.description
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: post.image_url
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_ResearchPost = (ResearchPost);

// EXTERNAL MODULE: ./src/global/StreamWidget/EmptyState/styled.ts
var EmptyState_styled = __webpack_require__(65299);
;// CONCATENATED MODULE: ./src/global/StreamWidget/EmptyState/EmptyResearch.tsx




var EmptyResearch_Text = ui/* Common.Text */.Gn.Text;
function EmptyResearch() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyState_styled/* EmptyStateWrapper */.$c, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/illustration/empty-research-stream.svg",
                alt: "Empty Stream Research"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState_styled/* ContentWrapper */.vs, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResearch_Text, {
                    size: "16px",
                    mt: "16px",
                    color: ui/* color.highgray */.$_.highgray,
                    children: "Belum ada postingan"
                })
            })
        ]
    });
}
/* harmony default export */ var EmptyState_EmptyResearch = (EmptyResearch);

;// CONCATENATED MODULE: ./src/global/StreamWidget/EmptyState/EmptySearch.tsx




var EmptySearch_Text = ui/* Common.Text */.Gn.Text;
function EmptySearch() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyState_styled/* EmptyStateWrapper */.$c, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/illustration/search-friends-not-found.svg",
                alt: "Empty Search Result"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState_styled/* ContentWrapper */.vs, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearch_Text, {
                    size: "14px",
                    mt: "16px",
                    color: ui/* color.highgray */.$_.highgray,
                    children: "Tidak ada hasil yang ditemukan"
                })
            })
        ]
    });
}
/* harmony default export */ var EmptyState_EmptySearch = (EmptySearch);

;// CONCATENATED MODULE: ./src/global/StreamWidget/EmptyState/EmptyCompanyPost.tsx




var EmptyCompanyPost_Text = ui/* Common.Text */.Gn.Text;
function EmptyCompanyPost() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyState_styled/* EmptyStateWrapper */.$c, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/illustration/empty-research-stream.svg",
                alt: "Empty Stream Research"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState_styled/* ContentWrapper */.vs, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCompanyPost_Text, {
                    size: "14px",
                    mt: "16px",
                    color: ui/* color.highgray */.$_.highgray,
                    children: "Belum ada postingan"
                })
            })
        ]
    });
}
/* harmony default export */ var EmptyState_EmptyCompanyPost = (EmptyCompanyPost);

;// CONCATENATED MODULE: ./src/global/StreamWidget/BlockedState/styled.ts

function BlockedState_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 60vh;\n"
    ]);
    BlockedState_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlockedState_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 32px;\n"
    ]);
    BlockedState_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlockedState_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    BlockedState_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BlockedState_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 369px;\n  color: ",
        ";\n"
    ]);
    BlockedState_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var BlockedState_styled_Text = ui/* Common.Text */.Gn.Text;
var BlockedStateWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5814f331-0"
})(BlockedState_styled_templateObject());
var Img = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-5814f331-1"
})(BlockedState_styled_templateObject1());
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5814f331-2"
})(BlockedState_styled_templateObject2(), BlockedState_styled_Text);
var BlockedDesc = (0,styled_components_browser_esm["default"])(BlockedState_styled_Text).withConfig({
    componentId: "sc-5814f331-3"
})(BlockedState_styled_templateObject3(), ui/* color.highgray */.$_.highgray);

;// CONCATENATED MODULE: ./src/global/StreamWidget/BlockedState/index.tsx



var BlockedState_Text = ui/* Common.Text */.Gn.Text;
var BlockedState = function(param) {
    var username = param.username;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockedStateWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                src: "/images/user-profile-blocked.png",
                alt: "Blocked stream"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockedState_Text, {
                        family: "bold",
                        size: "18px",
                        mb: "10px",
                        children: [
                            username,
                            " is blocked"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockedDesc, {
                        children: "Kamu tidak bisa melihat postingan ini maupun mengirim pesan. Buka untuk melihat postingan ini."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StreamWidget_BlockedState = (BlockedState);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
;// CONCATENATED MODULE: ./src/global/StreamWidget/NotesPost/constants.ts
var QUERY_FETCH_NOTES = "notes-stream-load";

// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/global/StreamWidget/Popover/index.tsx + 12 modules
var StreamWidget_Popover = __webpack_require__(77977);
// EXTERNAL MODULE: ./node_modules/react-string-replace-recursively/index.js
var react_string_replace_recursively = __webpack_require__(54253);
var react_string_replace_recursively_default = /*#__PURE__*/__webpack_require__.n(react_string_replace_recursively);
// EXTERNAL MODULE: ./src/utils/stream.js
var stream = __webpack_require__(14601);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/styled.ts
var TextContent_styled = __webpack_require__(31608);
;// CONCATENATED MODULE: ./src/global/StreamWidget/NotesPost/TextContent.tsx
/* eslint-disable react/no-array-index-key */ 









var TextContent_Text = ui/* Common.Text */.Gn.Text;
function TextContent_TextContent(param) {
    var content = param.content, maskedHtml = param.maskedHtml;
    var defaultHeight = 200;
    var MAX_TEXT_LENGTH = 400;
    var textRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(defaultHeight), contentHeight = ref[0], setContentHeight = ref[1];
    var ref1 = (0,react.useState)(false), isExpand = ref1[0], setIsExpand = ref1[1];
    var ref2 = (0,react.useState)(false), showReadMore = ref2[0], setShowReadMore = ref2[1];
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var parsedText = (0,react.useMemo)(function() {
        var tempParsedText = (0,stream/* parseEmoji */.qm)(content);
        var parsedHtml = maskedHtml;
        var config = {
            breaks: {
                pattern: /(\n|\r\n)/g,
                matcherFn: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                    });
                }
            },
            symbols: {
                pattern: /(\[%[a-z0-9]*%\])/gi,
                textFn: function(text) {
                    var cleanedSymbol = text.match(/\w+/g);
                    return cleanedSymbol;
                },
                matcherFn: function(rawText) {
                    var htmlData = parsedHtml[rawText];
                    var ref = htmlData.ref, text = htmlData.text, type = htmlData.type;
                    var textContent = text.substr(1);
                    if (type === "TYPE_COMPANY") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(ref),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_Popover/* PopoverCompany */.h, {
                                    symbol: textContent,
                                    children: text
                                })
                            })
                        });
                    }
                    if (type === "TYPE_USER") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: text
                        });
                    }
                    if (type === "TYPE_URL") {
                        var url = (ref === null || ref === void 0 ? void 0 : ref.includes("http")) ? ref : "https://".concat(ref);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: text
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: text
                    });
                }
            }
        };
        tempParsedText = react_string_replace_recursively_default()(config)(tempParsedText);
        return tempParsedText;
    }, [
        content
    ]);
    var handleExpand = function() {
        var text = textRef.current;
        setIsExpand(true);
        setContentHeight(text.offsetHeight);
    };
    (0,react.useEffect)(function() {
        if (!(textRef === null || textRef === void 0 ? void 0 : textRef.current)) return;
        var offsetHeight = textRef.current.offsetHeight;
        var isHeightOverflow = offsetHeight > contentHeight;
        setShowReadMore(isHeightOverflow);
    }, []);
    var hideLoggedInText = !isExpand && showReadMore && isLoggedIn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent_styled/* TextContainer */.l, {
                style: {
                    maxHeight: "".concat(contentHeight, "px")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent_styled/* FormatedText */.P, {
                    padding: "0px",
                    height: "1.55",
                    ref: textRef,
                    style: {
                        wordWrap: "break-word"
                    },
                    children: parsedText === null || parsedText === void 0 ? void 0 : parsedText.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item
                        }, i);
                    })
                })
            }, "stream-formatted-text"),
            hideLoggedInText && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent_Text, {
                color: ui/* color.primary */.$_.primary,
                onClick: handleExpand,
                style: {
                    cursor: "pointer"
                },
                children: "Read more..."
            }, "stream-readmore-text"),
            !isExpand && content.length > MAX_TEXT_LENGTH && !isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/register",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent_Text, {
                    color: ui/* color.primary */.$_.primary,
                    as: "a",
                    children: "Read more..."
                })
            })
        ]
    });
}
/* harmony default export */ var NotesPost_TextContent = (/*#__PURE__*/(0,react.memo)(TextContent_TextContent));

;// CONCATENATED MODULE: ./src/global/StreamWidget/NotesPost/styled.ts

function NotesPost_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  border-bottom: solid 1px ",
        ";\n"
    ]);
    NotesPost_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NotesPost_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #3A645C;\n  border-radius: 70px;\n  color: ",
        ";\n  display: flex;\n  margin: auto;\n  min-height: 50px;\n  min-width: 50px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 27px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    NotesPost_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NotesPost_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-body {\n    padding-top: 22px;\n  }\n\n  ",
        " {\n    max-height: 70vh;\n  }\n"
    ]);
    NotesPost_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NotesPost_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: flex;\n  margin-bottom: 16px;\n"
    ]);
    NotesPost_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var ModalAntd = ui/* Common.Modal */.Gn.Modal;
var NotesItemContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-7e4375b0-0"
})(NotesPost_styled_templateObject(), ui/* color.gainsboro */.$_.gainsboro);
var styled_ImagePlaceholder = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-7e4375b0-1"
})(NotesPost_styled_templateObject1(), ui/* color.light */.$_.light);
var ModalEditNoteWrapper = (0,styled_components_browser_esm["default"])(ModalAntd).withConfig({
    componentId: "sc-7e4375b0-2"
})(NotesPost_styled_templateObject2(), ContentContainer);
var OptionItemContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-7e4375b0-3"
})(NotesPost_styled_templateObject3());

// EXTERNAL MODULE: ./src/global/StreamWidget/Modals/ModalDelete/styled.ts
var ModalDelete_styled = __webpack_require__(2869);
;// CONCATENATED MODULE: ./src/global/StreamWidget/NotesPost/ModalDeleteNote.tsx



var ModalDeleteNote_Text = ui/* Common.Text */.Gn.Text;
function ModalDeleteNote(param) {
    var onCancel = param.onCancel, visible = param.visible, handleDelete = param.handleDelete;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_styled/* Modal */.u_, {
        visible: visible,
        onCancel: onCancel,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDeleteNote_Text, {
            size: "20px",
            height: "54px",
            family: "bold",
            children: "Delete Note"
        }),
        closeIcon: null,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_styled/* Button */.zx, {
                block: true,
                height: "40px",
                onClick: onCancel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDeleteNote_Text, {
                    align: "center",
                    family: "bold",
                    color: ui/* color.sunsetOrange */.$_.sunsetOrange,
                    children: "Cancel"
                })
            }, "cancel"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_styled/* Button */.zx, {
                block: true,
                type: "secondary",
                height: "40px",
                onClick: handleDelete,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDeleteNote_Text, {
                    align: "center",
                    family: "bold",
                    color: ui/* color.light */.$_.light,
                    children: "Delete"
                })
            }, "confirm"), 
        ],
        transitionName: "",
        maskTransitionName: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_styled/* ModalText */.iO, {
            size: "14px",
            height: "19px",
            align: "center",
            children: "Are you sure want to delete this note?"
        })
    });
}
/* harmony default export */ var NotesPost_ModalDeleteNote = (ModalDeleteNote);

;// CONCATENATED MODULE: ./src/global/StreamWidget/NotesPost/NotePost.tsx

















var NotePost_Flex = ui/* Common.Flex */.Gn.Flex, NotePost_Avatar = ui/* Common.Avatar */.Gn.Avatar, IconMoreOptions = ui/* Common.IconMoreOptions */.Gn.IconMoreOptions, NotePost_Popover = ui/* Common.Popover */.Gn.Popover, NotePost_Text = ui/* Common.Text */.Gn.Text;
var NotePost = function(param) {
    var data = param.data, handleClickEdit = param.handleClickEdit;
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref = (0,react.useState)(true), isImageAvailable = ref[0], setIsImageAvailable = ref[1];
    var ref1 = (0,react.useState)(false), showMenuPopover = ref1[0], setShowMenuPopover = ref1[1];
    var ref2 = (0,react.useState)(false), showModalDelete = ref2[0], setShowModalDelete = ref2[1];
    var containerId = "notes-option-".concat(data.id);
    var deleteNoteMutation = (0,useMutation/* useMutation */.D)({
        mutationFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", deleteNotes(data.id));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        onSuccess: function() {
            setShowModalDelete(false);
            (0,AlertMessage/* default */.Z)({
                content: "Note Deleted",
                alertType: "snackbar-dark",
                messageType: "success",
                hasCloseIcon: true
            });
            queryClient.invalidateQueries({
                queryKey: [
                    QUERY_FETCH_NOTES
                ]
            });
        }
    });
    var onClickCopy = function() {
        setShowMenuPopover(false);
        navigator.clipboard.writeText(data.content.text);
        (0,AlertMessage/* default */.Z)({
            content: "Text copied!",
            alertType: "snackbar-dark",
            messageType: "success",
            hasCloseIcon: true
        });
    };
    var onClickDelete = function() {
        setShowModalDelete(true);
        setShowMenuPopover(false);
    };
    var handleDelete = function() {
        deleteNoteMutation.mutate();
    };
    var onClickEdit = function() {
        handleClickEdit(data.id);
        setShowMenuPopover(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotesItemContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: containerId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotePost_Flex, {
                width: "100%",
                className: "header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_Popover/* PopoverCompany */.h, {
                        symbol: data.company.symbol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/symbol/".concat(data.company.symbol, "?source="),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: "dummy",
                                    style: {
                                        color: "unset"
                                    },
                                    children: [
                                        isImageAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotePost_Avatar, {
                                            size: "medium",
                                            padding: "0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                alt: "imageProfile",
                                                src: data.company.icon_url,
                                                onError: function() {
                                                    setIsImageAvailable(false);
                                                },
                                                style: {
                                                    cursor: "pointer"
                                                }
                                            })
                                        }),
                                        !isImageAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_ImagePlaceholder, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                children: !!data && data.company.symbol.toUpperCase().slice(0, 1)
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_styled/* HeaderContent */.oB, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotePost_Flex, {
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_Popover/* PopoverCompany */.h, {
                                            symbol: data.company.symbol,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/symbol/".concat(data.company.symbol, "?source="),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_styled/* TextHeader */.Y, {
                                                    size: "16px",
                                                    family: "bold",
                                                    children: data.company.symbol
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_styled/* TextHeader */.Y, {
                                            size: "12px",
                                            color: ui/* color.midgray */.$_.midgray,
                                            children: moment_default()(data.created_at).format("D MMM YY, HH:mm")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotePost_Popover, {
                                trigger: [
                                    "contextMenu",
                                    "click"
                                ],
                                placement: "bottomRight",
                                getPopupContainer: function() {
                                    return document.getElementById(containerId);
                                },
                                overlayStyle: {
                                    minWidth: "145px",
                                    paddingTop: 0
                                },
                                visible: showMenuPopover,
                                onVisibleChange: function(visible) {
                                    return setShowMenuPopover(visible);
                                },
                                autoAdjustOverflow: true,
                                content: function() {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_styled/* StreamOptionContainer */.JN, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionItemContainer, {
                                                onClick: onClickCopy,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        width: "16",
                                                        height: "15",
                                                        src: "icon/post-copy.svg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotePost_Text, {
                                                        ml: "12px",
                                                        children: "Copy Text"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionItemContainer, {
                                                onClick: onClickEdit,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        width: "16",
                                                        height: "15",
                                                        src: "icon/post-edit.svg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotePost_Text, {
                                                        ml: "12px",
                                                        children: "Edit Note"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionItemContainer, {
                                                onClick: onClickDelete,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        width: "16",
                                                        height: "15",
                                                        src: "icon/post-delete-red.svg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotePost_Text, {
                                                        ml: "12px",
                                                        color: "#EE4A49",
                                                        children: "Delete Note"
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMoreOptions, {
                                    onClick: function() {
                                        return setShowMenuPopover(!showMenuPopover);
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_styled/* ContentWrapper */.vs, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesPost_TextContent, {
                    content: data.content.masked_text,
                    maskedHtml: data.content.masks
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesPost_ModalDeleteNote, {
                handleDelete: handleDelete,
                onCancel: function() {
                    return setShowModalDelete(false);
                },
                visible: showModalDelete
            })
        ]
    });
};
/* harmony default export */ var NotesPost_NotePost = (NotePost);

;// CONCATENATED MODULE: ./src/global/StreamWidget/NotesPost/EmptyNotes.tsx



var EmptyNotes_Flex = ui/* Common.Flex */.Gn.Flex, EmptyNotes_Text = ui/* Common.Text */.Gn.Text;
var EmptyNotes = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyNotes_Flex, {
        align: "center",
        justify: "center",
        style: {
            height: 500
        },
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/notes/notes-empty.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNotes_Text, {
                size: "13px",
                weight: "bold",
                mt: "16px",
                children: "No Notes Available"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNotes_Text, {
                size: "13px",
                mt: "4px",
                children: "Add a new note from a company page"
            })
        ]
    });
};
/* harmony default export */ var NotesPost_EmptyNotes = (EmptyNotes);

;// CONCATENATED MODULE: ./src/global/StreamWidget/NotesPost/ModalEditNote.tsx



var ModalEditNote = function(param) {
    var visible = param.visible, symbol = param.symbol, companyName = param.companyName, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalEditNoteWrapper, {
        title: null,
        visible: visible,
        onCancel: onClose,
        width: 658,
        centered: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_NotesCompose, {
            defaultSymbol: symbol,
            companyName: companyName
        })
    });
};
/* harmony default export */ var NotesPost_ModalEditNote = (ModalEditNote);

;// CONCATENATED MODULE: ./src/global/StreamWidget/NotesPost/index.tsx















var NOTES_LIMIT = 10;
var NotesPost = function() {
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref = (0,react.useState)([]), notes = ref[0], setNotes = ref[1];
    var ref1 = (0,react.useState)({
        visible: false,
        symbol: null,
        companyName: null
    }), editModal = ref1[0], setEditModal = ref1[1];
    var ref2 = (0,useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            QUERY_FETCH_NOTES
        ],
        queryFn: function(param) {
            var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? undefined : _pageParam;
            return getNotes({
                cursor: pageParam,
                limit: NOTES_LIMIT
            });
        },
        getNextPageParam: function(lastPage) {
            var ref;
            var pagination = (lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.data).pagination;
            if (!pagination || pagination.next_cursor === "") {
                return undefined;
            }
            return pagination.next_cursor;
        },
        onSuccess: function(response) {
            var datasource = response.pages.flatMap(function(param) {
                var _data = param.data, responseData = _data.data;
                return responseData.notes;
            });
            setNotes(datasource);
        },
        retry: 0,
        refetchOnWindowFocus: false
    }), isLoading = ref2.isLoading, isRefetching = ref2.isRefetching, hasNextPage = ref2.hasNextPage, data = ref2.data, error = ref2.error, fetchNextPage = ref2.fetchNextPage;
    var handleLoadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isVisible) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isVisible && !isLoading && notes.length > 0 && hasNextPage) {
                            fetchNextPage();
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLoadMore(isVisible) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickEdit = function(id) {
        var note = notes.find(function(item) {
            return item.id === id;
        });
        if (note) {
            setEditModal(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    visible: true,
                    companyName: note.company.name,
                    symbol: note.company.symbol
                });
            });
        }
    };
    var handleCloseModalEdit = function() {
        queryClient.invalidateQueries({
            queryKey: [
                QUERY_FETCH_NOTES
            ]
        }).then(function() {
            setEditModal({
                visible: false,
                companyName: null,
                symbol: null
            });
        });
    };
    if (!data || isRefetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: (0,_to_consumable_array/* default */.Z)(new Array(5)).map(function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {});
            })
        });
    }
    if (!isRefetching && notes.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesPost_EmptyNotes, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            notes.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesPost_NotePost, {
                    data: item,
                    handleClickEdit: handleClickEdit
                }, item.id);
            }),
            !error && notes.length > 0 && hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                onChange: handleLoadMore,
                minTopValue: 200,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotesPost_ModalEditNote, {
                visible: editModal === null || editModal === void 0 ? void 0 : editModal.visible,
                symbol: editModal === null || editModal === void 0 ? void 0 : editModal.symbol,
                companyName: editModal === null || editModal === void 0 ? void 0 : editModal.companyName,
                onClose: handleCloseModalEdit
            })
        ]
    });
};
/* harmony default export */ var StreamWidget_NotesPost = (NotesPost);

;// CONCATENATED MODULE: ./src/global/StreamWidget/index.tsx










































var UnboxingStockWidget = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2076).then(__webpack_require__.bind(__webpack_require__, 32076));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32076)
            ];
        }
    },
    ssr: false
});
var StreamWidget_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
/**
 * Stream Widget component
 * @param {Object} props
 * @param {'generic' | 'user' | 'symbol'} props.type
 * @param {string} props.username
 * @param {string} props.symbol
 * @param {boolean} props.hideNavigation
 * @param {boolean} props.noBorder
 * @param {boolean} props.hasDefaultTab - is current navigation tab persisted in browser
 * @param {boolean} props.isUserBlocked
 * @param {string} props.companyName
 */ function StreamWidget(param) {
    var _type = param.type, type = _type === void 0 ? "generic" : _type, _username = param.username, username = _username === void 0 ? "" : _username, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _hideNavigation = param.hideNavigation, hideNavigation = _hideNavigation === void 0 ? false : _hideNavigation, _noBorder = param.noBorder, noBorder = _noBorder === void 0 ? false : _noBorder, _hasDefaultTab = param.hasDefaultTab, hasDefaultTab = _hasDefaultTab === void 0 ? false : _hasDefaultTab, _sentiment = param.sentiment, sentiment = _sentiment === void 0 ? null : _sentiment, entryPoint = param.entryPoint, isUserBlocked = param.isUserBlocked, companyName = param.companyName;
    var ref, ref1;
    var _STREAM_TABS = (0,_sliced_to_array/* default */.Z)(constants/* STREAM_TABS */.q1, 3), STREAM = _STREAM_TABS[0], NEWS = _STREAM_TABS[1], RESEARCH = _STREAM_TABS[2];
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,es/* useSelector */.v9)(StreamWidget_slice/* selectors */.wl), listStream = ref2.list, listResearch = ref2.listResearch, error = ref2.error, isLoading = ref2.isLoading, isLoadingMore = ref2.isLoadingMore, filterParams = ref2.filterParams, togglePinPost = ref2.togglePinPost, newPostCount = ref2.newPostCount, tabHeader = ref2.tabHeader, companyPinnedPost = ref2.companyPinnedPost;
    var ref3 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref3.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref4 = (0,es/* useSelector */.v9)(user_slice/* selectors */.wl), _pinnedPost = ref4.pinnedPost, pinnedPost = _pinnedPost.data;
    var isResearchStream = tabHeader === RESEARCH.value || filterParams.category === RESEARCH.value;
    var isNotesTab = filterParams.category === "notes";
    var list = (0,react.useMemo)(function() {
        if (isResearchStream) return listResearch;
        if (isNotesTab) return [];
        return listStream;
    }, [
        isResearchStream,
        listResearch,
        isNotesTab,
        listStream
    ]);
    // websocket selectors
    var wskey = (0,es/* useSelector */.v9)(slice/* wsKeySelector */.$4);
    var streamSocket = (0,es/* useSelector */.v9)(slice/* streamWsSelector */.Fy);
    var streamCategories = (0,utils/* getStreamCategories */.a9)(type);
    var localFilter = hasDefaultTab ? (0,utils/* getFilterParamFromLocalStorage */.i0)() : null;
    // Use post's template and its skeleton for common post, news, or research
    var isGenericNews = type === "generic" && tabHeader === NEWS.value || false;
    var PostItem = isGenericNews ? NewsPost : Post/* default */.Z;
    var SkeletonItem = Skeleton/* default */.Z;
    if (isResearchStream) SkeletonItem = Research;
    if (isGenericNews) SkeletonItem = News;
    var getFilterParamsData = function() {
        var reporttype = filterParams.reporttype, category = filterParams.category, filterType = filterParams.type, date = filterParams.date, rest = (0,_object_without_properties/* default */.Z)(filterParams, [
            "reporttype",
            "category",
            "type",
            "date"
        ]);
        var data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            category: category,
            streamType: type,
            username: username,
            symbol: symbol,
            type: filterType,
            tabHeader: tabHeader
        });
        if (hasDefaultTab) {
            data = (0,_object_spread/* default */.Z)({}, data, localFilter);
        }
        if (tabHeader === NEWS.value) {
            data.category = NEWS.value;
        }
        if (category === "reports") {
            data.reporttype = reporttype || constants/* reportCategories.0.key */.U1[0].key;
        }
        if (filterType === "trending") {
            data.date = data.date || moment_default()(Date.now()).format("YYYY-MM-DD");
        }
        if (data.category !== constants/* DEFAULT_TYPE */.Sb) {
            data.type = constants/* DEFAULT_TYPE */.Sb;
        }
        if (isResearchStream) {
            return {
                keyword: data.keyword,
                symbol: symbol || undefined
            };
        }
        return data;
    };
    var ref5 = (0,react.useState)(1), page = ref5[0], setPage = ref5[1];
    var ref6 = (0,react.useState)(false), openConversation = ref6[0], setOpenConversation = ref6[1];
    var ref7 = (0,react.useState)(null), selectedPostId = ref7[0], setSelectedPostId = ref7[1];
    var ref8 = (0,react.useState)(null), selectedParentId = ref8[0], setSelectedParentId = ref8[1];
    var ref9 = (0,react.useState)(false), isLastPage = ref9[0], setIsLastPage = ref9[1];
    var ref10 = (0,react.useState)(null), lastReplyId = ref10[0], setLastReplyId = ref10[1];
    var handleGetStream = function() {
        // category and type changed, get initial data
        var params = getFilterParamsData();
        if (isResearchStream) {
            dispatch(StreamWidget_slice/* effects.getResearchStream */.Sz.getResearchStream((0,_object_spread/* default */.Z)({}, params)));
        } else if (!isNotesTab) {
            dispatch(StreamWidget_slice/* effects.getStream */.Sz.getStream((0,_object_spread/* default */.Z)({}, params)));
        }
        setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    };
    // Clear all filter before open page
    // Clear all filter when username changed
    (0,react.useEffect)(function() {
        return function() {
            dispatch(StreamWidget_slice/* default.actions.resetFilterParam */.ZP.actions.resetFilterParam());
            // @ts-ignore
            dispatch(StreamWidget_slice/* default.actions.setTabHeader */.ZP.actions.setTabHeader(STREAM.value));
        };
    }, [
        username
    ]);
    // used to set default filter params
    (0,react.useEffect)(function() {
        if (filterParams.category === "") {
            var defaultFilter = {
                category: streamCategories[0].key,
                type: constants/* streamTypes.1.key */.J1[1].key
            };
            var filter = getFilterParamsData();
            if (hasDefaultTab) {
                filter = (0,_object_spread/* default */.Z)({}, defaultFilter, localFilter);
                if (localFilter.tabHeader) {
                    dispatch(StreamWidget_slice/* default.actions.setTabHeader */.ZP.actions.setTabHeader(localFilter.tabHeader));
                }
            } else {
                filter = defaultFilter;
            }
            dispatch(StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam(filter));
        } else {
            // category and type changed, get initial data
            handleGetStream();
            var filterType = filterParams.category === "reports" ? filterParams.reporttype : filterParams.type;
            if (filterType !== null) {
                (0,utils/* handleAnalyticsTabView */.wR)(filterParams.category, filterType);
            }
            // reset for loadmore action
            setIsLastPage(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        filterParams,
        tabHeader,
        symbol,
        isNotesTab
    ]);
    (0,react.useEffect)(function() {
        var EXCLUDED_CATEGORIES = [
            "prediction",
            "insider",
            ""
        ];
        if (!EXCLUDED_CATEGORIES.includes(filterParams.category)) {
            var filter = filterParams.category.toUpperCase();
            var channel = "*";
            if (symbol) {
                channel = "".concat(symbol);
            } else if (username) {
                channel = "P:".concat(username);
            }
            // update config if websocket has been connected
            if (wskey) {
                dispatch(// @ts-ignore
                slice/* actions.UPDATE_CHANNELS_CONFIG */.Nw.UPDATE_CHANNELS_CONFIG({
                    stream: [
                        "".concat(channel, ".").concat(filter)
                    ]
                }));
            }
        }
        return function() {
            // reset ws config on unmount
            dispatch(// @ts-ignore
            slice/* actions.UPDATE_CHANNELS_CONFIG */.Nw.UPDATE_CHANNELS_CONFIG({
                stream: []
            }));
        };
    }, [
        dispatch,
        filterParams,
        symbol,
        username,
        wskey
    ]);
    (0,react.useEffect)(function() {
        if (streamSocket) {
            dispatch(StreamWidget_slice/* default.actions.addNewPostCount */.ZP.actions.addNewPostCount());
        }
    }, [
        dispatch,
        streamSocket
    ]);
    var handleLoadMoreStream = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var lastPost, postid, lastReplyDate, params, loadMore, _payload, data, errorLoadMore;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        lastPost = list[list.length - 1];
                        postid = lastPost.postid, lastReplyDate = lastPost.last_reply_date;
                        params = getFilterParamsData();
                        if (filterParams.type === "trending") {
                            params.page = page + 1;
                            setPage(page + 1);
                        } else {
                            params.beforetimestamp = lastReplyDate;
                        }
                        params.lastpost = postid;
                        _ctx.next = 7;
                        return dispatch(StreamWidget_slice/* effects.loadMoreStream */.Sz.loadMoreStream((0,_object_spread/* default */.Z)({}, params)));
                    case 7:
                        loadMore = _ctx.sent;
                        _payload = loadMore.payload, data = _payload.data, errorLoadMore = _payload.error;
                        if (!errorLoadMore && data.length === 0) {
                            setIsLastPage(true);
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLoadMoreStream() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLoadMoreResearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var lastPost, id, params, loadMore, _payload, researchData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        lastPost = list[list.length - 1];
                        id = lastPost.id;
                        params = getFilterParamsData();
                        params.last_id = id;
                        _ctx.next = 6;
                        return dispatch(StreamWidget_slice/* effects.getResearchStream */.Sz.getResearchStream(params));
                    case 6:
                        loadMore = _ctx.sent;
                        _payload = loadMore.payload, researchData = _payload.data;
                        if ((researchData === null || researchData === void 0 ? void 0 : researchData.length) === 0) {
                            setIsLastPage(true);
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLoadMoreResearch() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLoadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isVisible) {
            var loadingData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        loadingData = isLoading || isLoadingMore;
                        if (!(isVisible && !loadingData && list.length > 0)) {
                            _ctx.next = 8;
                            break;
                        }
                        if (!isResearchStream) {
                            _ctx.next = 5;
                            break;
                        }
                        handleLoadMoreResearch();
                        return _ctx.abrupt("return");
                    case 5:
                        if (!isNotesTab) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        handleLoadMoreStream();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLoadMore(isVisible) {
            return _ref.apply(this, arguments);
        };
    }();
    // handle pin post
    (0,react.useEffect)(function() {
        if (togglePinPost.data && !togglePinPost.error) {
            // success pin/unpin stream
            handleGetStream();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        togglePinPost.data,
        togglePinPost.error
    ]);
    // get company pinned post
    (0,react.useEffect)(function() {
        if (symbol && type === "symbol") {
            dispatch(StreamWidget_slice/* effects.getCompanyPinnedPost */.Sz.getCompanyPinnedPost(symbol));
        }
    }, [
        symbol
    ]);
    var handleOpenConversation = function(post) {
        var ref;
        setSelectedPostId(post === null || post === void 0 ? void 0 : post.postid);
        setSelectedParentId(post === null || post === void 0 ? void 0 : post.parent_postid);
        setLastReplyId(post === null || post === void 0 ? void 0 : (ref = post.last_reply) === null || ref === void 0 ? void 0 : ref.postid);
    };
    var handleCloseConversation = function() {
        setOpenConversation(false);
        setSelectedPostId(null);
    };
    var handleDiscover = function() {
        router.push("/discover/people");
    };
    var hasCompanyPinnedPost = (0,react.useMemo)(function() {
        var ref;
        return filterParams.category !== "research" && type === "symbol" && (companyPinnedPost === null || companyPinnedPost === void 0 ? void 0 : (ref = companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.postid) && !isNotesTab;
    }, [
        filterParams,
        type,
        companyPinnedPost,
        isNotesTab
    ]);
    var isSelfStream = (0,react.useMemo)(function() {
        var ref = auth/* default.getUserAccess */.Z.getUserAccess(), tmp = ref.username, myUsername = tmp === void 0 ? "" : tmp;
        return username === myUsername;
    }, [
        username
    ]);
    var renderContent = function() {
        if (isLoading) {
            return (0,_to_consumable_array/* default */.Z)(new Array(5)).map(function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonItem, {});
            });
        }
        if (type === "user" && entryPoint === "user" && username && isUserBlocked) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_BlockedState, {
                username: username
            });
        }
        // Render Notes
        if (isNotesTab && type === "symbol") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(global_NotesCompose, {
                defaultSymbol: symbol,
                companyName: companyName
            });
        }
        if (isNotesTab && type === "user" && isSelfStream) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_NotesPost, {});
        }
        if (error && list.length === 0 || list.length === 0) {
            var ref, ref1;
            // Research Empty
            if (isResearchStream && ((ref = filterParams.keyword) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState_EmptyResearch, {});
            }
            // Search Result Empty
            if (((ref1 = filterParams.keyword) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState_EmptySearch, {});
            }
            if (type === constants/* STREAM_TYPE.SYMBOL */.R5.SYMBOL) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState_EmptyCompanyPost, {});
            }
            // Stream Empty
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* default */.Z, {
                onDiscover: handleDiscover
            });
        }
        // Render stream research post
        if (isResearchStream) {
            return list.map(function(post) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_ResearchPost, {
                    post: post
                });
            });
        }
        // Render stream
        return list.map(function(post, i) {
            var ref, ref1;
            // Hide pinned post in company/user stream list post
            var isPinnedPost = post.ispinned === 1 || post.postid === ((ref = pinnedPost[username]) === null || ref === void 0 ? void 0 : ref.postid);
            if (type !== "generic" && isPinnedPost) {
                return null;
            }
            if (hasCompanyPinnedPost && post.postid === (companyPinnedPost === null || companyPinnedPost === void 0 ? void 0 : (ref1 = companyPinnedPost.data) === null || ref1 === void 0 ? void 0 : ref1.postid)) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    i === 10 && type === "generic" && country === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnboxingStockWidget, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostItem, {
                        post: post,
                        onComment: function() {
                            return handleOpenConversation(post);
                        },
                        hasFollowingActivity: true,
                        isFirstPost: i === 0,
                        highlightWord: filterParams.keyword || "",
                        entryPoint: entryPoint,
                        symbol: symbol,
                        dataCyName: "stream-post-".concat(type, "-").concat(post.postid)
                    }, post.postid),
                    i === 20 && type === "generic" && /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryProvider/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_SuggestedPeopleWidget, {})
                    })
                ]
            });
        });
    };
    var activeCommentId = type === "generic" ? lastReplyId : selectedPostId;
    var visibilityTopValue = isResearchStream || isGenericNews ? 0 : 200;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_styled/* LineLoader */.fh, {
                isLoading: isLoading
            }),
            !isLoading && newPostCount > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_styled/* StreamNewPostBox */.kq, {
                onClick: handleGetStream,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamWidget_styled/* StreamNewPostText */.OD, {
                    children: [
                        newPostCount <= 10 ? newPostCount : "10+",
                        " new update(s)"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamWidget_styled/* StreamWidgetBox */.Vd, {
                noBorder: noBorder,
                newPostCount: newPostCount,
                children: [
                    !hideNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_Navigation, {
                        streamType: type,
                        hasDefaultTab: hasDefaultTab,
                        symbol: symbol,
                        isSelfStream: isSelfStream
                    }),
                    filterParams.category === "news" && sentiment,
                    hasCompanyPinnedPost && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: (companyPinnedPost === null || companyPinnedPost === void 0 ? void 0 : (ref = companyPinnedPost.data) === null || ref === void 0 ? void 0 : ref.research) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_ResearchPost, {
                            post: companyPinnedPost.data.research,
                            isPinned: true
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Post/* default */.Z, {
                            post: companyPinnedPost.data,
                            onComment: function() {
                                return handleOpenConversation(companyPinnedPost.data);
                            },
                            hasFollowingActivity: false,
                            isFirstPost: true,
                            highlightWord: filterParams.keyword || "",
                            entryPoint: entryPoint,
                            symbol: symbol,
                            pinned: true
                        }, (ref1 = companyPinnedPost.data) === null || ref1 === void 0 ? void 0 : ref1.postid)
                    }),
                    renderContent(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamConversation["default"], {
                        visible: openConversation,
                        postId: selectedPostId,
                        parentId: selectedParentId,
                        destroyOnClose: true,
                        activeCommentId: activeCommentId,
                        onCancel: handleCloseConversation,
                        openConversation: function() {
                            return setOpenConversation(true);
                        }
                    }),
                    !error && list.length > 0 && !isLastPage && /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                        onChange: handleLoadMore,
                        minTopValue: visibilityTopValue,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonItem, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(back_top/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_styled/* BackTopWrapper */.O8, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/widget-trending/icon-arrow-top.svg"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var global_StreamWidget = (StreamWidget);


/***/ }),

/***/ 59007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O8": function() { return /* binding */ BackTopWrapper; },
/* harmony export */   "OD": function() { return /* binding */ StreamNewPostText; },
/* harmony export */   "Vd": function() { return /* binding */ StreamWidgetBox; },
/* harmony export */   "fh": function() { return /* binding */ LineLoader; },
/* harmony export */   "kq": function() { return /* binding */ StreamNewPostBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* eslint-disable space-infix-ops */ /* eslint-disable indent */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            max-width: 100%;\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          max-width: calc(100% - 330px);\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n      border-radius: 4px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: solid 1px ",
        ";\n  border-radius: ",
        ";\n\n  &.guest-stream {\n    flex: 1;\n    max-width: 100%;\n\n    @media ",
        " {\n      ",
        "\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  border-bottom: none;\n  cursor: pointer;\n  border-radius: 3px 3px 0 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #a2a7b0; // this is intentionally hardcoded\n  border-radius: 50%;\n  bottom: 25px;\n  color: ",
        ";\n  right: 60px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    left: -200px;\n    width: 30%;\n  }\n  50% {\n    width: 30%;\n  }\n  70% {\n    width: 70%;\n  }\n  80% {\n    left: 50%;\n  }\n  95% {\n    left: 120%;\n  }\n  to {\n    left: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  height: 1px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background-color: #dadada;\n  display: ",
        ";\n\n  :before {\n    position: absolute;\n    content: '';\n    left: -200px;\n    width: 200px;\n    height: 1px;\n    background-color: #00ab6b;\n    animation: ",
        " 2s linear infinite;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
var StreamWidgetBox = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2f1ceddb-0"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, function(param) {
    var newPostCount = param.newPostCount;
    return newPostCount > 2 ? "0" : "3px";
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, function(param) {
    var isCompanyStock = param.isCompanyStock;
    if (isCompanyStock) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject());
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1());
}, function(param) {
    var noBorder = param.noBorder;
    return noBorder && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2());
});
var StreamNewPostBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    justify: "center",
    align: "center",
    py: "7px",
    // accessibility props
    role: "button"
}).withConfig({
    componentId: "sc-2f1ceddb-1"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var StreamNewPostText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).withConfig({
    componentId: "sc-2f1ceddb-2"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var BackTopWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    height: "40px",
    justify: "center",
    width: "40px"
}).withConfig({
    componentId: "sc-2f1ceddb-3"
})(_templateObject6(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var LineAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.keyframes)(_templateObject7());
var LineLoader = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2f1ceddb-4"
})(_templateObject8(), function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "block" : "none";
}, LineAnimation);



/***/ })

}]);